export const enum OrderStatus {
  /// <summary>待预定
  /// </summary>
  WaitBooking = 10101,
  /// <summary>待审批
  /// </summary>
  WaitApprove = 10103,
  /// <summary>待核价
  /// </summary>
  WaitConfirm = 10105,
  /// <summary>待支付/待确认/待审批
  /// </summary>
  WaitPayment = 10107,
  /// <summary>待处理
  /// </summary>
  WaitDispose = 10109,
  /// <summary>已完成
  /// </summary>
  Finished = 10113,
  /// <summary>已取消
  /// </summary>
  Canceled = 10115,
  /// <summary>已退回
  /// </summary>
  Rejected = 10117,
  /// <summary>已拆分
  /// </summary>
  Discrete = 10119,
  /// <summary>暂不能
  /// </summary>
  Cannot = 10121,
}
export const enum DealStatus {
  /// <summary>待预定
  /// </summary>
  WaitBooking = 10101,
  /// <summary>待审批
  /// </summary>
  WaitApprove = 10103,
  /// <summary>待确认
  /// </summary>
  WaitConfirm = 10105,
  /// <summary>待支付
  /// </summary>
  WaitPayment = 10107,
  /// <summary>待处理
  /// </summary>
  WaitDispose = 10109,
  /// <summary>已完成
  /// </summary>
  Finished = 10113,
  /// <summary>已取消
  /// </summary>
  Canceled = 10115,
  /// <summary>已退回
  /// </summary>
  Rejected = 10117,
  /// <summary>已拆分
  /// </summary>
  Discrete = 10119,
  /// <summary>暂不能
  /// </summary>
  Cannot = 10121,
}
// public class Actions
// {
//     /*
//      * SELECT DISTINCT '{'+ActionID+',"'+ActionName+'"},' FROM dbo.T_ActionInfo  WHERE UpperAction IN(101,30103)
//      */
//     public static Dictionary<int, string> actions = new Dictionary<int, string>()
//     {
//         {10101,"待预定"},
//         {10103,"待审批"},
//         {10105,"待确认"},
//         {10107,"待支付"},
//         {10109,"待处理"},
//         {10113,"已完成"},
//         {10115,"已取消"},
//         {10117,"已退回"},
//         {10119,"已拆分"},
//         {10121,"暂不能"},

//         {3010301,"待预定"},
//         {3010303,"待确认"},
//         {3010305,"待付款"},
//         {3010307,"待处理"},
//         {3010311,"已完成"},
//         {3010313,"暂不能"},
//         {3010315,"已退回"},
//         {3010317,"已取消"},

//         {10201,"待提交"},
//         {10203,"待核价"},
//         {10205,"待确认"} ,
//         {10209,"待退款"},
//         {10213,"已完成"},
//         {10215,"暂不能"},
//         {10217,"已退回"},
//         {10221,"已取消"},
// };

//     public static string MapName(int? ActionID)
//     {
//         return MapName(ActionID.Value);
//     }
//     public static string MapName(int ActionID)
//     {
//         string actionName;
//         if (actions.TryGetValue(ActionID, out actionName))
//         {
//             return actionName;
//         }
//         return "";
//     }
export const enum AmendStatus {
  /// <summary>待提交
  /// </summary>
  WaitSubmit = 10201,
  /// <summary>待核价
  /// </summary>
  WaitDispose = 10203,
  /// <summary>待确认
  /// </summary>
  WaitConfirm = 10205,
  /// <summary>待退款
  /// </summary>
  WaitRefund = 10209,
  /// <summary>已完成
  /// </summary>
  Finished = 10213,
  /// <summary>暂不能
  /// </summary>
  Cannot = 10215,
  /// <summary>已退回
  /// </summary>
  Rejected = 10217,
  /// <summary>已取消
  /// </summary>
  Canceled = 10221,
}
export const enum PolicyStatus {
  /// <summary>
  /// 待审核
  /// </summary>
  WaitThrowin = 3010101,
  /// <summary>
  /// 已上线
  /// </summary>
  Throwined = 3010103,
  /// <summary>
  /// 已下线
  /// </summary>
  Hanguped = 3010105,
  /// <summary>
  /// 已禁用
  /// </summary>
  Forbiddened = 3010107,
}
export const enum TourCustomerStatus {
  /// <summary>
  /// <summary>旅游客户订单状态
  /// </summary>
  TourCustomerOrder = 103,
  /// <summary>
  /// <summary>待提交
  /// </summary>
  WaitSubmit = 10301,
  /// <summary>
  /// <summary>待确认
  /// </summary>
  WaitConfirmed = 10302,
  /// <summary>
  /// <summary>待支付
  /// </summary>
  WaitPay = 10303,
  /// <summary>
  /// <summary>待审核
  /// </summary>
  WaitAudit = 10304,
  /// <summary>
  ///<summary>待处理
  ///</summary>
  Pending = 10305,
  /// <summary>
  /// <summary>处理完成
  /// </summary>
  Complate = 10306,
  /// <summary>
  ///<summary>已取消
  ///</summary>
  Canceled = 10307,
}
export const enum TourAmendOrderStatus {
  /// <summary>
  /// 待处理
  /// </summary>
  Pending = 3050501,
  /// <summary>
  /// 已提交
  /// </summary>
  Submited = 3050503,
  /// <summary>
  /// 审批通过
  /// </summary>
  Approve = 3050505,
  /// <summary>
  /// 审批拒绝
  /// </summary>
  ApproveReject = 3050507,
  /// <summary>
  /// 待定
  /// </summary>
  Undetermined = 3050509,
  /// <summary>
  /// 处理完成
  /// </summary>
  Finished = 3050511,
}
export const enum FlightPolicyState {
  /// <summary>
  ///<summary>待审批
  ///</summary>
  FlightWaitPolicy = 3070101,
  /// <summary>
  ///<summary>已上线
  ///</summary>
  FlightOnlinePolicy = 3070102,
  /// <summary>
  ///<summary>已下线
  ///</summary>
  FlightDownPolicy = 3070103,
  /// <summary>
  ///<summary>已禁用
  ///</summary>
  FlightDisablePolicy = 3070104,
}
export const enum FlightCNOrderState {
  /// <summary>
  /// 待审批
  /// </summary>
  ApprovalPending = 3070301,
  /// <summary>
  /// 审批拒绝
  /// </summary>
  Turndown = 3070302,
  /// <summary>
  /// 待处理
  /// </summary>
  Pending = 3070303,
  /// <summary>
  /// 待出票
  /// </summary>
  StayTicke = 3070304,
  /// <summary>
  /// 出票退回
  /// </summary>
  TicketBack = 3070305,
  /// <summary>
  /// 暂不能
  /// </summary>
  Useless = 3070306,
  /// <summary>
  /// 核价单
  /// </summary>
  Single = 3070307,
  /// <summary>
  /// 改签核价单
  /// </summary>
  ChlikSingle = 3070308,
  /// <summary>
  /// 待支付
  /// </summary>
  WaitPay = 3070309,
  /// <summary>
  /// 处理完成
  /// </summary>
  Pended = 3070310,
  /// <summary>
  /// 已出票
  /// </summary>
  IssueTicket = 3070311,
  /// <summary>
  /// 已改签
  /// </summary>
  Changed = 3070312,
  /// <summary>
  /// 已退票
  /// </summary>
  Refunded = 3070313,
}
export const enum InterFlightPolicyState {
  /// <summary>
  ///<summary>待审批
  ///</summary>
  InterFlightWaitPolicy = 3090101,
  /// <summary>
  ///<summary>已上线
  ///</summary>
  InterFlightOnlinePolicy = 3090102,
  /// <summary>
  ///<summary>已下线
  ///</summary>
  InterFlightDownPolicy = 3090103,
  /// <summary>
  ///<summary>已禁用
  ///</summary>
  InterFlightDisablePolicy = 3090104,
}
export const enum TrainOrderStatus {
  ///<summary>占座中
  ///</summary>
  SeatIn = 3150101,
  ///<summary>占座失败
  ///</summary>
  SeatFail = 3150102,
  ///<summary>待支付
  ///</summary>
  WaitPay = 3150103,
  ///<summary>出票成功
  ///</summary>
  EtdzSucc = 3150104,
  /// <summary>已取消
  /// </summary>
  Canceled = 3150105,
  /// <summary> 已退票
  /// </summary>
  TrainAmend = 3150106,
  /// <summary>
  /// 出票失败
  /// </summary>
  EtdzFail = 3150107,
  /// <summary>
  /// 已改签
  /// </summary>
  TrainChange = 3150108,
  /// <summary>
  /// 改签失败
  /// </summary>
  ChangeFail = 3150109,
  /// <summary>
  /// 改签中
  /// </summary>
  InAChange = 3150110,
  /// <summary>
  /// 退票中
  /// </summary>
  InARefund = 3150111,
}
export const enum TrainAmendOrderStatus {
  /// <summary>
  /// 待确认
  /// </summary>
  Waitconfirme = 3150201,
  /// <summary>
  /// 已退票
  /// </summary>
  TrainAmend = 3150202,
}
export const enum HotelRefund {
  /// <summary>
  /// 未处理
  /// </summary>
  Pending = 3110501,
  /// <summary>
  /// 暂不能
  /// </summary>
  Useless = 3110503,
  /// <summary>
  /// 已提交
  /// </summary>
  Approve = 3110504,
  /// <summary>
  /// 客退供已提
  /// </summary>
  GuestReturn = 3110505,
  /// <summary>
  /// 客未退供已提
  /// </summary>
  GuestCarried = 3110506,
  /// <summary>
  /// 已退款
  /// </summary>
  Refunded = 3110507,
}
export class AirportInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  CityID?: number;
  CityName?: string;
  CityCode?: string;
  CitySpell?: string;
  CityShortSpell?: string;
  CityEName?: string;
  AirportID?: number;
  AirportName?: string;
  AirportCode?: string;
  AirportSpell?: string;
  AirportShortSpell?: string;
  AirportEName?: string;
  Lang?: string;
}

export class AirwayEntity {
  ///<summary>二字码(Update)
  ///</summary>
  AirwayCode?: string;
  ///<summary>三字码
  ///</summary>
  Code?: string;
  ///<summary>地区
  ///</summary>
  Country?: string;
  ///<summary>中文名称
  ///</summary>
  AirwayCName?: string;
  ///<summary>英文名称
  ///</summary>
  AirwayEName?: string;
  ///<summary>是否国内
  ///</summary>
  IsInternal?: boolean;

  ///<summary>二字码
  ///</summary>
}

export class AirwayInfoEntity {
  PageNo?: number;
  PageSize?: number;
  AirwayID?: number;
  AirwayCode?: string;
  CountryID?: number;
  CountryCode?: string;
  Country?: string;
  AirwayCName?: string;
  AirwayEName?: string;
  Lang?: string;
}

export class AreaInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  Lang?: string;
}

export class BerthEntity {
  ///<summary>舱位编号
  ///</summary>
  BID?: number;
  ///<summary>航空公司
  ///</summary>
  Carrier?: string;
  ///<summary>舱位
  ///</summary>
  Class?: string;
  ///<summary>折扣
  ///</summary>
  Discount?: number;
  ///<summary>更新日期
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;

  ///<summary>舱位编号
  ///</summary>
}

export class BerthInfoEntity {
  PageNo?: number;
  PageSize?: number;
  BerthID?: number;
  BerthCode?: string;
  BerthName?: string;
  StandardCode?: string;
  AirwayCode?: string;
  Discount?: number;
  ApplyArea?: number;
  ///<summary>修改日期
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
}
export class BusinessInfoEntity {
  BusinessId?: string;
  BusinessName?: string;
  CityId?: string;
  OuterId?: string;
  ChannelCode?: string;
  Lang?: string;
}
export class CategoryInfoEntity {
  CategoryID?: number;
  BaseID?: number;
  CategoryTitle?: string;
  CategoryName?: string;
  CategoryCode?: string;
  CategoryOrder?: number;
  CategoryDefault?: number;
  CategoryRemark?: string;
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
}
export const enum Categorys {
  ///<summary>公司类型
  ///</summary>
  CompanyType = 111,
  ///<summary>资本类型
  ///</summary>
  CapitalType = 112,
  ///<summary>公司规模
  ///</summary>
  CompanySize = 113,
  ///<summary>适用区域
  ///</summary>
  ApplyArea = 114,
  ///<summary>证件类型
  ///</summary>
  CardType = 115,
  ///<summary>用户状态
  ///</summary>
  UserStatus = 116,
  ///<summary>性别
  ///</summary>
  Sex = 117,
  ///<summary>是否
  ///</summary>
  YesOrNo = 118,
  ///<summary>国内航程类型
  ///</summary>
  ChinaVoyageType = 119,
  ///<summary>角色类型
  ///</summary>
  RoleType = 120,
  ///<summary>支付方式
  ///</summary>
  PaymentType = 121,
  ///<summary>航班类型
  ///</summary>
  FlightType = 122,
  ///<summary>乘客类型
  ///</summary>
  ConsumerType = 123,
  ///<summary>账单周期
  ///</summary>
  BillCycle = 124,
  ///<summary>服务方式
  ///</summary>
  ServiceMode = 125,
  ///<summary>计算方式
  ///</summary>
  CalcPriceMode = 126,
  ///<summary>计算基准
  ///</summary>
  CalcBenchmark = 127,
  ///<summary>运行环境
  ///</summary>
  RuntimeEnvironment = 130,
  ///<summary>工作状态
  ///</summary>
  WorkStatus = 135,
  ///<summary>数据范围
  ///</summary>
  DataRange = 136,
  ///<summary>授权状态
  ///</summary>
  AuthorizeState = 137,
  ///<summary>角色类别
  ///</summary>
  RoleCategory = 138,
  ///<summary>事件类型
  ///</summary>
  EventType = 139,
  ///<summary>发票状态
  ///</summary>
  InvoiceStatus = 140,
  ///<summary>收款状态
  ///</summary>
  ReceiveStatus = 142,
  ///<summary>付款状态
  ///</summary>
  PaymentStatus = 143,
  ///<summary>价格单位
  ///</summary>
  UnitPrice = 144,
  ///<summary>交易方式
  ///</summary>
  TradeType = 145,
  ///<summary>订单类型
  ///</summary>
  ProductType = 146,
  ///<summary>文件类型
  ///</summary>
  FileType = 147,
  ///<summary>留言类型
  ///</summary>
  MessageType = 148,
  ///<summary>出游状态
  ///</summary>
  TravelStatus = 150,
  ///<summary>收款方式
  ///</summary>
  ReceivableType = 152,
  ///<summary>销售类型
  ///</summary>
  BusinessType = 153,
  ///<summary>安全类型
  ///</summary>
  SecurityType = 154,
  ///<summary>来源
  ///</summary>
  CreateMode = 155,
  ///<summary>服务类别
  ///</summary>
  ServiceType = 156,
  ///<summary>问题类型
  ///</summary>
  ProblemType = 157,
  ///<summary>联系方式
  ///</summary>
  ContactType = 158,
  ///<summary>全局配置
  ///</summary>
  SetsType = 159,
  ///<summary>团期状态
  ///</summary>
  TeamStatus = 160,
  ///<summary>价格状态
  ///</summary>
  PriceStatus = 161,
  ///<summary>政策类型
  ///</summary>
  PolicyType = 162,
  ///<summary>收付款类别
  ///</summary>
  ReceiveOrPay = 163,
  ///<summary>帐单状态
  ///</summary>
  TradeStatus = 164,
  ///<summary>审批状态
  ///</summary>
  AuditStatus = 165,
  ///<summary>申请状态
  ///</summary>
  ApplyStatus = 166,
  ///<summary>退团状态
  ///</summary>
  RefundStatus = 167,
  ///<summary>区域类型
  ///</summary>
  ZoneType = 168,
  ///<summary>取票方式
  ///</summary>
  TicketDelivery = 169,
  ///<summary>票本类型
  ///</summary>
  TicketType = 170,
  ///<summary>返回机场
  ///</summary>
  BackAirportType = 171,
  ///<summary>适用对象
  ///</summary>
  ApplicableObject = 172,
  ///<summary>适用价格
  ///</summary>
  ApplyPrice = 173,
  ///<summary>适用周期
  ///</summary>
  ApplyWeek = 174,
  ///<summary>不适用旅客资质
  ///</summary>
  LimitPassageType = 175,
  ///<summary>运价基础中含规则
  ///</summary>
  FreightBasicsRule = 176,
  ///<summary>儿童奖励规则
  ///</summary>
  ChildrewardRules = 177,
  ///<summary>婴儿奖励规则
  ///</summary>
  BabywardRules = 178,
  ///<summary>换编码规则
  ///</summary>
  CodingRule = 179,
  ///<summary>国际航程类型
  ///</summary>
  InterVoyageType = 180,
  ///<summary>扣点类型
  ///</summary>
  PointsType = 181,
  ///<summary>航线类型
  ///</summary>
  AirlineType = 182,
  ///<summary>旅行须知类型
  ///</summary>
  InformationsType = 183,
  ///<summary>通知方式类型
  ///</summary>
  NotificationType = 184,
  ///<summary>审批消息类型
  ///</summary>
  ExamineType = 185,
  ///<summary>火车座位类型
  ///</summary>
  TrainSeatType = 186,
  ///<summary>机票舱位
  ///</summary>
  Cabin = 187,
  ///<summary>最低价准则
  ///</summary>
  LowestRule = 188,
  ///<summary>火车类型
  ///</summary>
  TrainType = 189,
  ///<summary>适用情况
  ///</summary>
  ApplicableCase = 190,
  ///<summary>服务费类型
  ///</summary>
  CollectFeesType = 191,
  ///<summary>差旅原因类型
  ///</summary>
  TravelReasonType = 192,
  ///<summary>机票退票原因
  ///</summary>
  FlightRefundReason = 193,
  ///<summary>预定类型
  ///</summary>
  BookingType = 195,
  ///<summary>审批记录类型
  ///</summary>
  ApprovalRecordType = 196,
  ///<summary>预定方式
  ///</summary>
  ReservationMode = 197,
  ///<summary>服务时间类型
  ///</summary>
  ServiceTimeType = 198,
  ///<summary>审批规则类型
  ///</summary>
  ScreeningRulesType = 199,
  ///<summary>航班状态
  ///</summary>
  FlightTimeStatus = 200,
  ///<summary>规则类型
  ///</summary>
  RuleType = 201,
  ///<summary>机票费用类型
  ///</summary>
  ExpensesType = 202,
  ///<summary>延期类型
  ///</summary>
  DelayType = 203,

  ActiveStatus = 208,
  ///<summary>处理流程
  ///</summary>
  FlowMode = 210,
  ///<summary>账户类型
  ///</summary>
  AccountType = 212,
  ///<summary>授信类型
  ///</summary>
  CreditType = 214,
  ///<summary>账单状态
  ///</summary>
  BillStatus = 216,
  ///<summary>酒店退票原因
  ///</summary>
  HotelRefundReason = 220,
  ///<summary>发票角色
  ///</summary>
  InvoiceRole = 222,
  ///<summary>发票类型
  ///</summary>
  InvoiceType = 224,
  ///<summary>取票类型
  ///</summary>
  TakeType = 226,
  /// <summary>授权类型
  /// </summary>
  AuthType = 228,
  /// <summary>通知类型
  /// </summary>
  NotifyType = 230,
  /// <summary>逾期状态
  /// </summary>
  OverdueStatus = 232,
  /// <summary>成员类型
  /// </summary>
  MemberType = 236,
  ///<summary>通知内容类型
  ///</summary>
  NotifyContentType = 240,
  ///<summary>通知范围
  ///</summary>
  NotifyScope = 242,
  ///<summary>快递类型
  ///</summary>
  ExpressType = 244,
  ServiceSecne = 255,
  TrafficGrade = 257,
}
export const enum CompanyType {
  /// <summary>公司类型类别编号
  /// </summary>
  CategoryID = 111,
  ///<summary>企事业单位
  ///</summary>
  EnterprisesUnit = 1100,
  ///<summary>政府机关
  ///</summary>
  GovernmentDepartment = 1101,
}
export const enum CapitalType {
  /// <summary>资本类型类别编号
  /// </summary>
  CategoryID = 112,
  ///<summary>民营资产
  ///</summary>
  PeopleEnterprises = 1102,
  ///<summary>国有资产
  ///</summary>
  CountryCapital = 1103,
  ///<summary>中外合资
  ///</summary>
  ChinaOuterJoinCapital = 1104,
  ///<summary>外商独资
  ///</summary>
  ForeignCompany = 1105,
}
export const enum CompanySize {
  /// <summary>公司规模类别编号
  /// </summary>
  CategoryID = 113,
  ///<summary>100人以下
  ///</summary>
  CompanySize100 = 1106,
  ///<summary>100~499
  ///</summary>
  CompanySize499 = 1107,
  ///<summary>500~999
  ///</summary>
  CompanySize999 = 1108,
  ///<summary>1000~4999
  ///</summary>
  CompanySize4999 = 1109,
  ///<summary>5000以上
  ///</summary>
  CompanySize5kUp = 1110,
}
export const enum ApplyArea {
  /// <summary>适用区域类别编号
  /// </summary>
  CategoryID = 114,
  ///<summary>国内
  ///</summary>
  Internal = 1126,
  ///<summary>国际
  ///</summary>
  Overseas = 1127,
}
export const enum CardType {
  /// <summary>证件类型类别编号
  /// </summary>
  CategoryID = 115,
  ///<summary>身份证
  ///</summary>
  IDCard = 1138,
  ///<summary>护照
  ///</summary>
  PassportCard = 1139,
  ///<summary>学生证
  ///</summary>
  StudentCard = 1140,
  ///<summary>军人证
  ///</summary>
  OfficerCard = 1141,
  ///<summary>其它
  ///</summary>
  OtherCard = 1142,
  /// <summary>
  /// 港澳台居民居住证
  /// </summary>
  Residencepermit = 1296,
  /// <summary>
  /// 外国人永久居留身份证
  /// </summary>
  ForeignResidentIDCard = 1297,
  ///<summary>港澳通行证
  ///</summary>
  HKMpermit = 1298,
  ///<summary>台湾通行证
  ///</summary>
  TaiWpermit = 1299,
  /// <summary>台湾居民居住证
  /// </summary>
  TaiwanResidencepermit = 1230,
  ///<summary>出生证明
  ///</summary>
  birthcertificate = 1231,
  /// <summary>
  /// 户口簿
  /// </summary>
  Residencebooklet = 1232,
  /// <summary>
  /// 台胞证
  /// </summary>
  Taiwancompatriotsyndrome = 1233,
  /// <summary>
  /// 回乡证
  /// </summary>
  ReturnPermit = 1234,
}

export const enum UserStatus {
  /// <summary>用户状态类别编号
  /// </summary>
  CategoryID = 116,
  ///<summary>启用
  ///</summary>
  Enable = 1143,
  ///<summary>禁用
  ///</summary>
  UnEnable = 1144,
}
export const enum Sex {
  /// <summary>性别类别编号
  /// </summary>
  CategoryID = 117,
  ///<summary>男
  ///</summary>
  Male = 1145,
  ///<summary>女
  ///</summary>
  Female = 1146,
}
export const enum YesOrNo {
  /// <summary>是否类别编号
  /// </summary>
  CategoryID = 118,
  ///<summary>是
  ///</summary>
  Yes = 1150,
  ///<summary>否
  ///</summary>
  No = 1151,
}
export const enum VoyageType {
  /// <summary>国内航程类型类别编号
  /// </summary>
  CategoryID = 119,
  ///<summary>单程
  ///</summary>
  SingleVoyage = 1161,
  ///<summary>往返
  ///</summary>
  RoundVoyage = 1162,
  ///<summary>回程
  ///</summary>
  ReturnVoyage = 1163,
  ///<summary>联程
  ///</summary>
  ConnectVoyage = 1167,
}
export const enum RoleType {
  /// <summary>角色类型类别编号
  /// </summary>
  CategoryID = 120,
  ///<summary>用户
  ///</summary>
  User = 1311,
  ///<summary>职位
  ///</summary>
  Jobs = 1312,
  ///<summary>群组
  ///</summary>
  Group = 1313,
  ///<summary>部门
  ///</summary>
  Department = 1314,
  ///<summary>公司
  ///</summary>
  Company = 1315,
  ///<summary>服务
  ///</summary>
  Service = 1316,
  ///<summary>客户
  ///</summary>
  Customer = 1317,

  ///<summary>权限
  ///</summary>
  Action = 1318,
  ///<summary>成本中心
  ///</summary>
  CostCenter = 1319,
}
/// <summary>支付方式
/// </summary>
export const enum PaymentType {
  /// <summary>支付方式类别编号
  /// </summary>
  CategoryID = 121,
  ///<summary>预付
  ///</summary>
  Prepay = 1195,
  ///<summary>现付
  ///</summary>
  CashPay = 1196,
}
/// <summary>航班类型
/// </summary>
export const enum FlightType {
  /// <summary>航班类型类别编号
  /// </summary>
  CategoryID = 122,
  ///<summary>普通航班
  ///</summary>
  CommonFlight = 1193,
  ///<summary>共享航班
  ///</summary>
  ShareFlight = 1194,
}
/// <summary>乘客类型
/// </summary>
export const enum ConsumerType {
  /// <summary>乘客类型类别编号
  /// </summary>
  CategoryID = 123,
  ///<summary>婴儿 0±~2±
  ///</summary>
  Infant = 1701,
  ///<summary>儿童 2±~18±
  ///</summary>
  Enfant = 1703,
  ///<summary>成人 18±~40±
  ///</summary>
  Young = 1705,
  ///<summary>中年 40±~60±
  ///</summary>
  Wrinkly = 1707,
  /// <summary>老年 60±
  /// </summary>
  Elderly = 1709,
}
/// <summary>账单周期
/// </summary>
export const enum BillCycle {
  /// <summary>账单周期类别编号
  /// </summary>
  CategoryID = 124,
  ///<summary>月
  ///</summary>
  MonthCycle = 1260,
  ///<summary>周
  ///</summary>
  WeekCycle = 1261,
  ///<summary>日
  ///</summary>
  DayCycle = 1262,
}
/// <summary>服务方式
/// </summary>
export const enum ServiceMode {
  /// <summary>服务方式类别编号
  /// </summary>
  CategoryID = 125,
  ///<summary>线上服务
  ///</summary>
  OnlineServiceMode = 1300,
  ///<summary>线下服务
  ///</summary>
  LineServiceMode = 1301,
}
/// <summary>计算方式
/// </summary>
export const enum CalcPriceMode {
  /// <summary>计算方式类别编号
  /// </summary>
  CategoryID = 126,
  ///<summary>百分比
  ///</summary>
  PercentageMode = 1302,
  ///<summary>固定金额
  ///</summary>
  FixedPrice = 1303,
}
/// <summary>计算基准
/// </summary>
export const enum CalcBenchmark {
  /// <summary>计算基准类别编号
  /// </summary>
  CategoryID = 127,
  ///<summary>票面价
  ///</summary>
  ExpensePrice = 1304,
  ///<summary>票面价+税费
  ///</summary>
  PriceFareAndTax = 1305,
}
/// <summary>运行环境
/// </summary>
export const enum RuntimeEnvironment {
  /// <summary>运行环境类别编号
  /// </summary>
  CategoryID = 130,
  ///<summary>服务端
  ///</summary>
  Server = 1320,
  ///<summary>客户端
  ///</summary>
  Client = 1321,
}
/// <summary>工作状态
/// </summary>
export const enum WorkStatus {
  /// <summary>工作状态类别编号
  /// </summary>
  CategoryID = 135,
  ///<summary>正常
  ///</summary>
  Normal = 1325,
  ///<summary>变更
  ///</summary>
  Change = 1326,
}
/// <summary>数据范围
/// </summary>
export const enum DataRange {
  /// <summary>数据范围类别编号
  /// </summary>
  CategoryID = 136,
  ///<summary>仅自己
  ///</summary>
  SelfOnly = 1330,
  ///<summary>自己及下级
  ///</summary>
  SelfLower = 1331,
  ///<summary>不限制
  ///</summary>
  NoLimit = 1332,
  ///<summary>本部门
  ///</summary>
  Department = 1513,
  ///<summary>本部门及下级
  ///</summary>
  DepartmentLower = 1514,
}
/// <summary>授权状态
/// </summary>
export const enum AuthorizeState {
  /// <summary>授权状态类别编号
  /// </summary>
  CategoryID = 137,
  ///<summary>未授权
  ///</summary>
  UnAuthorized = 1335,
  ///<summary>已授权
  ///</summary>
  Authorized = 1336,
}
/// <summary>角色类别
/// </summary>
export const enum RoleCategory {
  /// <summary>角色类别类别编号
  /// </summary>
  CategoryID = 138,
  ///<summary>系统角色
  ///</summary>
  SystemRole = 1350,
  ///<summary>用户角色
  ///</summary>
  UserRole = 1351,
}
/// <summary>事件类型
/// </summary>
export const enum EventType {
  /// <summary>事件类型类别编号
  /// </summary>
  CategoryID = 139,
  ///<summary>继续之前
  ///</summary>
  ContinueBefore = 1356,
  ///<summary>继续之后
  ///</summary>
  ContinueAfter = 1357,
  ///<summary>退回之前
  ///</summary>
  ReturnBefore = 1358,
  ///<summary>退回之后
  ///</summary>
  ReturnAfter = 1359,
  ///<summary>变更之前
  ///</summary>
  ChangeBefore = 1360,
  ///<summary>变更之后
  ///</summary>
  ChangeAfter = 1361,
}
/// <summary>发票状态
/// </summary>
export const enum InvoiceStatus {
  /// <summary>发票状态类别编号
  /// </summary>
  CategoryID = 140,
  ///<summary>需要发票
  ///</summary>
  NeedInvoice = 1362,
  ///<summary>不要发票
  ///</summary>
  NoInvoice = 1363,
}
/// <summary>价格单位
/// </summary>
export const enum UnitPrice {
  /// <summary>价格单位类别编号
  /// </summary>
  CategoryID = 144,
  ///<summary>元
  ///</summary>
  RMB = 1369,
  ///<summary>美元
  ///</summary>
  Dollar = 1370,
}
/// <summary>交易方式
/// </summary>
export const enum TradeMode {
  /// <summary>交易方式类别编号
  /// </summary>
  CategoryID = 145,
  ///<summary>支付宝
  ///</summary>
  Alipay = 1371,
  ///<summary>微信
  ///</summary>
  WeChat = 1372,
  ///<summary>现金
  ///</summary>
  Cash = 1373,
  ///<summary>月结
  ///</summary>
  Monthly = 1374,

  ///<summary>Pos
  ///</summary>
  Pos = 1376,

  ///<summary>转账
  ///</summary>
  Transfer = 1483,
}
/// <summary>文件类型
/// </summary>
export const enum FileType {
  /// <summary>文件类型类别编号
  /// </summary>
  CategoryID = 147,
  ///<summary>出团通知书
  ///</summary>
  AdviceNote = 1378,
  ///<summary>客人附件
  ///</summary>
  GuestEnclosure = 1379,
  ///<summary>其他
  ///</summary>
  other = 1381,
  ///<summary>电子合同
  ///</summary>
  Electronic = 1382,
}
/// <summary>留言类型
/// </summary>
export const enum MessageType {
  /// <summary>留言类型类别编号
  /// </summary>
  CategoryID = 148,
  ///<summary>给客人留言
  ///</summary>
  ClientMessage = 1383,
  ///<summary>给供应留言
  ///</summary>
  SupplyMessage = 1384,
  ///<summary>给同事留言
  ///</summary>
  WorkmateMessage = 1385,
}
/// <summary>出游状态
/// </summary>
export const enum TravelStatus {
  /// <summary>出游状态类别编号
  /// </summary>
  CategoryID = 150,
  ///<summary>已出游
  ///</summary>
  Traveled = 1390,
  ///<summary>未出游
  ///</summary>
  NotTravel = 1391,
}
/// <summary>销售类型
/// </summary>
export const enum BusinessType {
  /// <summary>销售类型类别编号
  /// </summary>
  CategoryID = 153,
  ///<summary>改换
  ///</summary>
  Change = 1789,
  ///<summary>销售
  ///</summary>
  Sales = 1797,

  // Change=1395
  // Sales=1397
  /////<summary>退款
  /////</summary>
  // Refund = 1398,

  ///<summary>产品
  ///</summary>
  Product = 1795,
  ///<summary>退费
  ///</summary>
  Amend = 1799,
  ///<summary>账务
  ///</summary>
  Bill = 1791,
  ///<summary>发票
  ///</summary>
  Invoice = 1792,
  ///<summary>公司
  ///</summary>
  Company = 1793,
  ///<summary>个人
  ///</summary>
  People = 1801,
}
/// <summary>安全类型
/// </summary>
export const enum SecurityType {
  /// <summary>安全类型类别编号
  /// </summary>
  CategoryID = 154,
  ///<summary>登录密码
  ///</summary>
  PasswordVerify = 1399,
  ///<summary>邮箱验证
  ///</summary>
  EmailVerify = 1400,
  ///<summary>手机验证
  ///</summary>
  PhoneVerify = 1401,
  ///<summary>实名验证
  ///</summary>
  NameVerify = 1402,
  ///<summary>安全问题
  ///</summary>
  SafetyProblem = 1403,
}

/// <summary>下单方式
/// </summary>
export const enum CreateMode {
  /// <summary>下单方式类别编号
  /// </summary>
  CategoryID = 155,
  ///<summary>网站
  ///</summary>
  WEB = 1404,

  ///<summary>网站
  ///</summary>
  APP = 1405,

  ///<summary>客服
  ///</summary>
  Customer = 1803,
  ///<summary>需求
  ///</summary>
  Demand = 1984,
}
/// <summary>服务类别
/// </summary>
export const enum ServiceType {
  /// <summary>服务类别类别编号
  /// </summary>
  CategoryID = 156,
  ///<summary>商旅服务
  ///</summary>
  BtripService = 1406,
  ///<summary>酒店服务
  ///</summary>
  HotelService = 1407,
  ///<summary>旅游服务
  ///</summary>
  TourService = 1408,
  ///<summary>机票服务
  ///</summary>
  FlightService = 1409,
  ///<summary>保险服务
  ///</summary>
  InsuranceService = 1466,
  ///<summary>快递服务
  ///</summary>
  ExpressService = 1467,
  ///<summary>发票服务
  ///</summary>
  InvoiceService = 1468,
  ///<summary>签证服务
  ///</summary>
  VisaService = 1469,
  ///<summary>火车服务
  ///</summary>
  TrainService = 1470,
  ///<summary>餐饮服务
  ///</summary>
  CaterService = 1554,
  ///<summary>交通服务
  ///</summary>
  TrafficService = 1555,
  ///<summary>商城服务
  ///</summary>
  MallService = 1556,
  ///<summary>基础服务
  ///</summary>
  BaseService = 1557,
  ///<summary>系统服务
  ///</summary>
  SystemService = 1636,
  /// <summary>工作服务
  /// </summary>
  WorkService = 1637,
  ///<summary>订单服务
  ///</summary>
  OrderService = 1638,
  ///<summary>账单服务
  ///</summary>
  BillService = 1640,
  ///<summary>个人服务
  ///</summary>
  UserService = 1643,
  /// <summary>企业服务
  /// </summary>
  CompanyService = 1645,
  /// <summary>增值服务
  /// </summary>
  ChargeService = 1410,
}
/// <summary>问题类型
/// </summary>
export const enum ProblemType {
  /// <summary>问题类型类别编号
  /// </summary>
  CategoryID = 157,
  ///<summary>高中班主任是谁
  ///</summary>
  HightDirector = 1411,
  ///<summary>第一次通关的游戏
  ///</summary>
  Firstgame = 1412,
}
/// <summary>联系方式
/// </summary>
export const enum ContactType {
  /// <summary>联系方式类别编号
  /// </summary>
  CategoryID = 158,
  ///<summary>手机
  ///</summary>
  PhoneContact = 1413,
  ///<summary>电话
  ///</summary>
  TelephoneContact = 1414,
  ///<summary>邮箱
  ///</summary>
  EmailContact = 1415,
  ///<summary>QQ
  ///</summary>
  QQ = 1416,
}
/// <summary>全局配置
/// </summary>
export const enum SetsType {
  /// <summary>全局配置类别编号
  /// </summary>
  CategoryID = 159,
  ///<summary>网上预订须知
  ///</summary>
  OnlineKnow = 1417,
  ///<summary>国内旅游预订须知
  ///</summary>
  TourKnow = 1418,
}
/// <summary>团期状态
/// </summary>
export const enum TeamStatus {
  /// <summary>团期状态类别编号
  /// </summary>
  CategoryID = 160,
  ///<summary>启用
  ///</summary>
  Enable = 1419,
  ///<summary>禁用
  ///</summary>
  UnEnable = 1420,
}
/// <summary>价格状态
/// </summary>
export const enum PriceStatus {
  /// <summary>价格状态类别编号
  /// </summary>
  CategoryID = 161,
  ///<summary>价格启用
  ///</summary>
  PriceEnable = 1421,
  ///<summary>价格禁用
  ///</summary>
  PriceUnEnable = 1422,
  ///<summary>价格待定
  ///</summary>
  Indeterminate = 1423,
}
/// <summary>政策类型
/// </summary>
export const enum PolicyType {
  /// <summary>政策类型类别编号
  /// </summary>
  CategoryID = 162,
  ///<summary>私有政策
  ///</summary>
  PrivatePolicy = 1426,
  ///<summary>公有政策
  ///</summary>
  PublicPolicy = 1427,
}
/// <summary>收付款类别
/// </summary>
export const enum TradeType {
  /// <summary>收付款类别类别编号
  /// </summary>
  CategoryID = 163,
  ///<summary>收款
  ///</summary>
  Receive = 1428,
  ///<summary>付款
  ///</summary>
  Payment = 1429,
}

/// <summary>帐单状态
/// </summary>
export const enum TradeStatus {
  /// <summary>帐单状态类别编号
  /// </summary>
  CategoryID = 164,
  ///<summary>待提交
  ///</summary>
  WaitSubmit = 1610,
  ///<summary>待付款
  ///</summary>
  WaitPayment = 1612,
  ///<summary>未确认
  ///</summary>
  WaitConfirm = 1614,
  ///<summary>已确认
  ///</summary>
  Finished = 1616,
  ///<summary>已取消
  ///</summary>
  Canceled = 1618,
  ///<summary>已退回
  ///</summary>
  Rejected = 1620,
}

/// <summary>审批状态
/// </summary>
export const enum AuditStatus {
  /// <summary>审批状态类别编号
  /// </summary>
  CategoryID = 165,
  ///<summary>未审批
  ///</summary>
  Unaudit = 1434,
  ///<summary>已审批
  ///</summary>
  Audited = 1435,
  ///<summary>审批拒绝
  ///</summary>
  AuditRefuse = 1436,
}
/// <summary>申请状态
/// </summary>
export const enum ApplyStatus {
  /// <summary>申请状态类别编号
  /// </summary>
  CategoryID = 166,
  ///<summary>未提交
  ///</summary>
  Unsubmit = 1432,
  ///<summary>已提交
  ///</summary>
  Submited = 1433,
}
/// <summary>退团状态
/// </summary>
export const enum RefundStatus {
  /// <summary>退团状态类别编号
  /// </summary>
  CategoryID = 167,
  ///<summary>未处理
  ///</summary>
  Untreated = 1438,
  ///<summary>退团失败
  ///</summary>
  RefundeBad = 1439,
  ///<summary>退团处理中
  ///</summary>
  RefundeIng = 1440,
  ///<summary>退团成功&#x0D,

  ///</summary>
  Refunded = 1441,
}
/// <summary>区域类型
/// </summary>
export const enum ZoneType {
  /// <summary>区域类型类别编号
  /// </summary>
  CategoryID = 168,
  ///<summary>国家
  ///</summary>
  Country = 1442,
  ///<summary>景区
  ///</summary>
  Scenic = 1443,
  ///<summary>城市
  ///</summary>
  City = 1444,
  ///<summary>省
  ///</summary>
  Province = 1445,
  ///<summary>区域
  ///</summary>
  Area = 1446,
  ///<summary>机场
  ///</summary>
  Airport = 1447,
  ///<summary>洲
  ///</summary>
  Continent = 1448,
  ///<summary>区
  ///</summary>
  District = 1449,
  ///<summary>车站
  ///</summary>
  Station = 1807,
}
/// <summary>取票方式
/// </summary>
export const enum TicketDelivery {
  /// <summary>取票方式类别编号
  /// </summary>
  CategoryID = 169,
  ///<summary>自取
  ///</summary>
  Invite = 1450,
  ///<summary>邮寄
  ///</summary>
  Mail = 1451,
}
/// <summary>票本类型
/// </summary>
export const enum TicketType {
  /// <summary>票本类型类别编号
  /// </summary>
  CategoryID = 170,
  ///<summary>BSP
  ///</summary>
  BSP = 1164,
  ///<summary>B2B
  ///</summary>
  B2B = 1165,
  ///<summary>境外电子
  ///</summary>
  OverseasElectronic = 1166,
  ///<summary>B2C
  ///</summary>
  B2C = 1980,
  ///<summary>B2G
  ///</summary>
  B2G = 1982,
  ///<summary>BSG
  ///</summary>
  BSG = 1983,
  /// <summary>销售策略
  /// </summary>
  SAP = 1981,
}
/// <summary>返回机场
/// </summary>
export const enum BackAirportType {
  /// <summary>返回机场类别编号
  /// </summary>
  CategoryID = 171,
  ///<summary>同一洲际范围内
  ///</summary>
  WithinIntercontinental = 1180,
  ///<summary>政策始发机场范围
  ///</summary>
  PolicyDepartAirport = 1181,
  ///<summary>必须返回行程出发机场
  ///</summary>
  MustBackAirport = 1184,
  ///<summary>指定返回国家或机场范围
  ///</summary>
  AppointBackAirport = 1185,
}
/// <summary>适用对象
/// </summary>
export const enum ApplicableObject {
  /// <summary>适用对象类别编号
  /// </summary>
  CategoryID = 172,
  ///<summary>团队
  ///</summary>
  Team = 1168,
  ///<summary>散客
  ///</summary>
  Fit = 1169,
  ///<summary>不限
  ///</summary>
  Unlimited = 1170,
}
/// <summary>适用价格
/// </summary>
export const enum ApplyPrice {
  /// <summary>适用价格类别编号
  /// </summary>
  CategoryID = 173,
  ///<summary>高开
  ///</summary>
  HighOpen = 1171,
  ///<summary>低开
  ///</summary>
  DownOpen = 1172,
}
/// <summary>适用周期
/// </summary>
export const enum ApplyWeek {
  /// <summary>适用周期类别编号
  /// </summary>
  CategoryID = 174,
  ///<summary>星期一
  ///</summary>
  Monday = 1173,
  ///<summary>星期二
  ///</summary>
  Tuesday = 1174,
  ///<summary>星期三
  ///</summary>
  Wednesday = 1175,
  ///<summary>星期四
  ///</summary>
  Thursday = 1176,
  ///<summary>星期五
  ///</summary>
  Friday = 1177,
  ///<summary>星期六
  ///</summary>
  Saturday = 1178,
  ///<summary>星期日
  ///</summary>
  Sunday = 1179,
}
/// <summary>不适用旅客资质
/// </summary>
export const enum LimitPassageType {
  /// <summary>不适用旅客资质类别编号
  /// </summary>
  CategoryID = 175,
  ///<summary>留学生
  ///</summary>
  OverseasStudent = 1200,
  ///<summary>移民
  ///</summary>
  Immigrant = 1201,
  ///<summary>劳工
  ///</summary>
  Worker = 1202,
  ///<summary>海员
  ///</summary>
  Seaman = 1203,
  ///<summary>青年
  ///</summary>
  Youth = 1204,
  ///<summary>港澳台
  ///</summary>
  HkMacaoTw = 1205,
  ///<summary>外籍
  ///</summary>
  ForeignNationality = 1206,
  ///<summary>非汉字姓名
  ///</summary>
  NotChineseName = 1207,
  ///<summary>Add-On
  ///</summary>
  AddOn = 1208,
  ///<summary>老年
  ///</summary>
  OldGge = 1209,
  ///<summary>境外中转
  ///</summary>
  OverseasTransfer = 1210,
  ///<summary>缺口程
  ///</summary>
  NotchRange = 1211,
  ///<summary>OPEN
  ///</summary>
  OPEN = 1212,
  ///<summary>SPA
  ///</summary>
  SPA = 1213,
  ///<summary>Q值
  ///</summary>
  QValue = 1214,
  ///<summary>共享航班
  ///</summary>
  SharedFlight = 1215,
  ///<summary>三方协议
  ///</summary>
  ThreeAgreement = 1216,
  ///<summary>套票
  ///</summary>
  Package = 1217,
  ///<summary>整团
  ///</summary>
  WholeGroup = 1218,
  ///<summary>小团
  ///</summary>
  SmallGroup = 1219,
}
/// <summary>运价基础中含规则
/// </summary>
export const enum FreightBasicsRule {
  /// <summary>运价基础中含规则类别编号
  /// </summary>
  CategoryID = 176,
  ///<summary>无奖励
  ///</summary>
  NoReward = 1182,
  ///<summary>无代理费
  ///</summary>
  AgencyFreeFee = 1183,
}
/// <summary>儿童奖励规则
/// </summary>
export const enum ChildrewardRules {
  /// <summary>儿童奖励规则类别编号
  /// </summary>
  CategoryID = 177,
  ///<summary>奖励与成人一样
  ///</summary>
  RewardsAdults = 1220,
  ///<summary>可无开奖励
  ///</summary>
  NoOpenBonus = 1221,
  ///<summary>可开无代理费
  ///</summary>
  openAgencyFee = 1463,
  ///<summary>不可开
  ///</summary>
  NoWay = 1464,
}
/// <summary>婴儿奖励规则
/// </summary>
export const enum BabywardRules {
  /// <summary>婴儿奖励规则类别编号
  /// </summary>
  CategoryID = 178,
  ///<summary>可开无奖励
  ///</summary>
  WithoutReward = 1222,
  ///<summary>不可开
  ///</summary>
  NotOpen = 1223,
}
/// <summary>换编码规则
/// </summary>
export const enum CodingRule {
  /// <summary>换编码规则类别编号
  /// </summary>
  CategoryID = 179,
  ///<summary>无需还编码
  ///</summary>
  NoCodingRequired = 1224,
  ///<summary>换编码出票
  ///</summary>
  CodeOut = 1225,
  ///<summary>大编出票（无需换编）
  ///</summary>
  BigTicket = 1226,
  ///<summary>大编出票（需换编）
  ///</summary>
  BigNoTicket = 1227,
  ///<summary>无位不换出票（外放有位时换编）
  ///</summary>
  NoChange = 1228,
}
/// <summary>扣点类型
/// </summary>
export const enum PointsType {
  /// <summary>扣点类型类别编号
  /// </summary>
  CategoryID = 181,
  ///<summary>直接修改
  ///</summary>
  DirectUpdate = 1306,
  ///<summary>加点
  ///</summary>
  AddLittle = 1307,
  ///<summary>减点
  ///</summary>
  ReduceLittle = 1308,
}
/// <summary>航线类型
/// </summary>
export const enum AirlineType {
  /// <summary>航线类型类别编号
  /// </summary>
  CategoryID = 182,
  ///<summary>国内始发
  ///</summary>
  insideOutside = 1452,
  ///<summary>直飞SOTO程
  ///</summary>
  outsideInside = 1453,
  ///<summary>国内始发Add-On
  ///</summary>
  insideInsideOutside = 1454,
  ///<summary>国外始发Add-On
  ///</summary>
  outsideInsideInside = 1455,
  ///<summary>境外到境外
  ///</summary>
  outsideOutside = 1456,
  ///<summary>国内始发中转
  ///</summary>
  insideOutsideOutside = 1457,
  ///<summary>国外始发中转
  ///</summary>
  outsideOutsideInside = 1458,
  ///<summary>境外境外境外
  ///</summary>
  outsideOutsideOutside = 1459,
  ///<summary>境外境内境外
  ///</summary>
  outsideInsideOutside = 1460,
  ///<summary>全球到全球
  ///</summary>
  globalGlobal = 1461,
  ///<summary>全球中转全球
  ///</summary>
  globalGlobalGlobal = 1462,
}
/// <summary>旅行须知类型
/// </summary>
export const enum InformationsType {
  /// <summary>旅行须知类型类别编号
  /// </summary>
  CategoryID = 183,
  ///<summary>预定须知
  ///</summary>
  TravelNotes = 1471,
  ///<summary>费用须知
  ///</summary>
  ExpenseKnowledge = 1472,
}
/// <summary>通知方式类型
/// </summary>
export const enum NotificationType {
  /// <summary>通知方式类型类别编号
  /// </summary>
  CategoryID = 184,
  ///<summary>短信
  ///</summary>
  ShortMessage = 1473,
  ///<summary>邮件
  ///</summary>
  Mail = 1474,
  ///<summary>微信
  ///</summary>
  Wechat = 1475,
}
/// <summary>审批消息类型
/// </summary>
export const enum ExamineType {
  /// <summary>审批消息类型类别编号
  /// </summary>
  CategoryID = 185,
  ///<summary>审批订单消息内容
  ///</summary>
  EexamineOrderSms = 1476,
  ///<summary>审批通过消息内容
  ///</summary>
  EexamineApprovalSms = 1477,
  ///<summary>审批拒绝消息内容
  ///</summary>
  EexamineRefuseSms = 1478,
  ///<summary>订单处理完成消息内容
  ///</summary>
  EexamineAccomplishSms = 1479,
  ///<summary>退款完成
  ///</summary>
  Refunds = 1480,
}
/// <summary>火车座位类型
/// </summary>
export const enum TrainSeatType {
  /// <summary>火车座位类型类别编号
  /// </summary>
  CategoryID = 186,
  ///<summary>商务座
  ///</summary>
  BusinessSeat = 1485,
  ///<summary>特等座
  ///</summary>
  SpecialSeat = 1486,
  ///<summary>一等座
  ///</summary>
  Level1Seat = 1487,
  ///<summary>二等座
  ///</summary>
  Level2Seat = 1488,
  ///<summary>高级软卧
  ///</summary>
  HighGradeSleeper = 1489,
  ///<summary>软卧
  ///</summary>
  CommonSleeper = 1490,
  ///<summary>硬卧
  ///</summary>
  HardSleeper = 1491,
  ///<summary>软座
  ///</summary>
  SoftSeat = 1492,
  ///<summary>硬座
  ///</summary>
  HardSeat = 1493,
  ///<summary>无座
  ///</summary>
  NotHaveSeat = 1494,
  ///<summary>动卧
  ///</summary>
  MotionSupine = 1495,

  ///<summary>一等卧
  ///</summary>
  Level1Sleeper = 1497,
  ///<summary>二等卧
  ///</summary>
  Level2Sleeper = 1499,
}
/// <summary>机票舱位
/// </summary>
export const enum Cabin {
  /// <summary>机票舱位类别编号
  /// </summary>
  CategoryID = 187,
  ///<summary>经济舱
  ///</summary>
  Economy = 1496,
  ///<summary>商务舱
  ///</summary>
  Buissenes = 1498,
  ///<summary>头等舱
  ///</summary>
  First = 1500,
  ///<summary>5折经济舱
  ///</summary>
  Economy5 = 1851,
  ///<summary>6折经济舱
  ///</summary>
  Economy6 = 1853,
  ///<summary>7折经济舱
  ///</summary>
  Economy7 = 1855,
  ///<summary>8折经济舱
  ///</summary>
  Economy8 = 1857,
  ///<summary>9折经济舱
  ///</summary>
  Economy9 = 1859,
}
/// <summary>最低价准则
/// </summary>
export const enum LowestRule {
  /// <summary>最低价准则类别编号
  /// </summary>
  CategoryID = 188,

  ///<summary>管控最低价
  ///</summary>
  ControLowestPrice = 1501,

  ///<summary>全天最低价
  ///</summary>
  DayLowestPrice = 1502,

  ///<summary>时段最低价
  ///</summary>
  TimeAreaLowestPrice = 1503,

  ///<summary>全航班最低价
  ///</summary>
  FlightLowestPrice = 1504,

  ///<summary>无限制
  ///</summary>
  NoLimit = 0,
}
/// <summary>火车类型
/// </summary>
export const enum TrainType {
  /// <summary>火车类型类别编号
  /// </summary>
  CategoryID = 189,
  ///<summary>高铁
  ///</summary>
  HighSpeedRail = 1505,
  ///<summary>卧铺
  ///</summary>
  SleepingBerth = 1506,
  ///<summary>普车及其它
  ///</summary>
  Other = 1507,
}
/// <summary>适用情况
/// </summary>
export const enum ApplicableCase {
  /// <summary>适用情况类别编号
  /// </summary>
  CategoryID = 190,
  ///<summary>全部
  ///</summary>
  Whole = 1508,
  ///<summary>职位
  ///</summary>
  Position = 1509,
  ///<summary>部门
  ///</summary>
  Department = 1510,
}
/// <summary>服务费类型
/// </summary>
export const enum CollectFeesType {
  /// <summary>服务费类型类别编号
  /// </summary>
  CategoryID = 191,
  ///<summary>按固定收费
  ///</summary>
  FlatFeeCharges = 1511,
  ///<summary>按百分比收费
  ///</summary>
  PercentageCostFee = 1512,
}
/// <summary>差旅原因类型
/// </summary>
export const enum TravelReasonType {
  /// <summary>差旅原因类型类别编号
  /// </summary>
  CategoryID = 192,
  ///<summary>差旅目的
  ///</summary>
  TravelPurpose = 1515,
  ///<summary>政策原因
  ///</summary>
  PolicyCause = 1516,
  ///<summary>预定须知
  ///</summary>
  BookingInfo = 1528,
}
/// <summary>机票退票原因
/// </summary>
export const enum FlightRefundReason {
  /// <summary>机票退票原因类别编号
  /// </summary>
  CategoryID = 193,
  ///<summary>我要改变行程,不想飞了
  ///</summary>
  FlightChange = 1517,
  ///<summary>记错行程、日期、时间、姓名
  ///</summary>
  FlightMistaken = 1518,
  ///<summary>航班延误或取消
  ///</summary>
  FlightDelay = 1519,
}
/// <summary>预定类型
/// </summary>
export const enum BookingType {
  /// <summary>预定类型类别编号
  /// </summary>
  CategoryID = 195,
  ///<summary>因公
  ///</summary>
  OnBusiness = 1529,
  ///<summary>因私
  ///</summary>
  OnPersonal = 1530, //OnPersonal
}
/// <summary>审批记录类型
/// </summary>
export const enum ApprovalRecordType {
  /// <summary>审批记录类型类别编号
  /// </summary>
  CategoryID = 196,
  ///<summary>订单支付审批
  ///</summary>
  PayApproval = 1531,
  ///<summary>订单改签审批
  ///</summary>
  ChangeApproval = 1532,
  ///<summary>订单退票审批
  ///</summary>
  ReturnTicketApproval = 1533,
}
/// <summary>预定方式
/// </summary>
export const enum ReservationMode {
  /// <summary>预定方式类别编号
  /// </summary>
  CategoryID = 197,
  ///<summary>线上预定
  ///</summary>
  OnLineReservation = 1536,
  ///<summary>线下预定
  ///</summary>
  OffLineReservation = 1537,
}
/// <summary>服务时间类型
/// </summary>
export const enum ServiceTimeType {
  /// <summary>服务时间类型类别编号
  /// </summary>
  CategoryID = 198,
  ///<summary>工作时间
  ///</summary>
  WorkingTime = 1538,
  ///<summary>非工作时间
  ///</summary>
  NonWorkingTime = 1539,
}
/// <summary>审批规则类型
/// </summary>
export const enum ScreeningRulesType {
  /// <summary>审批规则类型类别编号
  /// </summary>
  CategoryID = 199,

  ///<summary>线上预定需要审批
  ///</summary>
  OnlineBookingApproval = 1541,
  ///<summary>线下预定需要审批
  ///</summary>
  OfflineBookingApproval = 1542,
  ///<summary>违背规则需要审批
  ///</summary>
  ViolateRuleApproval = 1545,
  ///<summary>更改行程需要审批
  ///</summary>
  ChangeTripApproval = 1546,
  ///<summary>取消行程需要审批
  ///</summary>
  CancelTripApproval = 1547,
  IntentTripApproval = 1580,
  ///<summary>必需选择成本中心
  ///</summary>
  CostCenterRequire = 1543,
  ///<summary>必需填写项目代码
  ///</summary>;
  ProjectCodeRequire = 1544,
  ///<summary>必需填写违背原因
  ///</summary>
  ContraryReasonRequire = 1540,
  ///<summary>必需填写审批单号
  ///</summary>
  ApprovalNoRequire = 1582,
  ///<summary>允许填写审批单号
  ApprovalDisplayOnly = 1584,
}
/// <summary>航班状态
/// </summary>
export const enum FlightTimeStatus {
  /// <summary>航班状态类别编号
  /// </summary>
  CategoryID = 200,
  ///<summary>起飞前
  ///</summary>
  Preflight = 1548,
  ///<summary>起飞后
  ///</summary>
  AfterTakeoff = 1549,
}
/// <summary>规则类型
/// </summary>
export const enum RuleType {
  /// <summary>规则类型类别编号
  /// </summary>
  CategoryID = 201,
  ///<summary>改签
  ///</summary>
  RuleEndorse = 1550,
  ///<summary>退票
  ///</summary>
  RuleFund = 1551,
  ///<summary>预定
  ///</summary>
  Reserve = 1553,
}
/// <summary>机票费用类型
/// </summary>
export const enum ExpensesType {
  /// <summary>机票费用类型类别编号
  /// </summary>
  CategoryID = 202,
  ///<summary>按人收费
  ///</summary>
  People = 1534,
  ///<summary>按航段收费
  ///</summary>
  legs = 1535,
}
/// <summary>延期类型
/// </summary>
export const enum DelayType {
  /// <summary>延期类型类别编号
  /// </summary>
  CategoryID = 203,
  ///<summary>自愿
  ///</summary>
  Volunteer = 1559,
  ///<summary>航变
  ///</summary>
  FlightChang = 1561,
  ///<summary>重购
  ///</summary>
  BuyAgain = 1563,
  ///<summary>病退
  ///</summary>
  SickAmend = 1565,
  ///<summary>名字错误
  ///</summary>
  NameError = 1567,
  ///<summary>升舱换开
  ///</summary>
  CabinChange = 1569,
  ///<summary>废票
  ///</summary>
  TicketInvalid = 1571,
  ///<summary>其他
  ///</summary>
  Other = 1573,
}

/// <summary>价格类型
/// </summary>
export const enum PriceType {
  /// <summary>价格类型类别编号
  /// </summary>
  CategoryID = 204,
  ///<summary>票面
  ///</summary>
  TicketFare = 1660,
  ///<summary>机建
  ///</summary>
  BuildFare = 1662,
  ///<summary>燃油
  ///</summary>
  FuelFare = 1664,
  ///<summary>税费
  ///</summary>
  TaxFare = 1666,
  ///<summary>保险
  ///</summary>
  SafeFare = 1668,
  ///<summary>服务
  ///</summary>
  ServiceFare = 1670,
  ///<summary>房费
  ///</summary>
  HotelFare = 1672,
  /// <summary>团费
  /// </summary>
  TeamFare = 1674,
  /// <summary>退票
  /// </summary>
  AmendFare = 1678,
  /// <summary>变更
  /// </summary>
  ChangeFare = 1682,
  /// <summary>原价
  /// </summary>
  OldPrice = 1684,

  /// <summary>其它
  /// </summary>
  OtherFare = 1690,
  /// <summary>直减
  /// </summary>
  DirectReduction = 1692,
  ///<summary>折扣
  ///</summary>
  ThrowDiscount = 1694,
}

/// <summary>活动状态
/// </summary>
export const enum ActiveStatus {
  /// <summary>价格类型类别编号
  /// </summary>
  CategoryID = 208,
  ///<summary>待提交
  ///</summary>
  WaitSubmit = 1750,
  ///<summary>待处理
  ///</summary>
  WaitDispose = 1752,
  ///<summary>暂不能
  //////</summary>
  Cannot = 1754,
  ///<summary>已完成
  ///</summary>
  Finished = 1756,

  ///<summary>已拒绝
  ///</summary>
  Rejected = 1758,
}

/// <summary>处理流程
/// </summary>
export const enum FlowMode {
  /// <summary>处理流程
  /// </summary>
  CategoryID = 210,
  ///<summary>账单
  ///</summary>
  Bill = 1760,
}

/// <summary>账户类型
/// </summary>
export const enum AccountType {
  ///<summary>账户类型
  ///</summary>
  CategoryID = 212,
  ///<summary>余额
  ///</summary>
  Balance = 1765,
  ///<summary>信用
  ///</summary>
  Credit = 1767,
  ///<summary>积分
  ///</summary>
  Integral = 1769,
}
/// <summary>授信类型
/// </summary>
export const enum CreditType {
  ///<summary>授信类型
  ///</summary>
  CategoryID = 214,
  ///<summary>固定授信
  ///</summary>
  FixedCredit = 1771,
  ///<summary>临时授信
  ///</summary>
  InterimCredit = 1773,
}
/// <summary>账单状态
/// </summary>
export const enum BillStatus {
  ///<summary>账单状态
  ///</summary>
  CategoryID = 216,
  ///<summary>待出帐
  ///</summary>
  WaitOutDay = 1777,
  ///<summary>待审核
  ///</summary>
  WaitAudited = 1779,
  ///<summary>待确认
  ///</summary>
  WaitConfirm = 1781,
  ///<summary>待收款
  ///</summary>
  WaitReceive = 1783,
  ///<summary>已关账
  ///</summary>
  Finished = 1785,
  ///<summary>已退回
  ///</summary>
  Rejected = 1787,
}
/// <summary>酒店退票原因
/// </summary>
export const enum HotelRefundReason {
  ///<summary>酒店退票原因
  ///</summary>
  CategoryID = 220,
  ///<summary>行程变更
  ///</summary>
  HotelChange = 1805,
  ///<summary>行程取消
  ///</summary>
  HotelDelay = 1837,
}
/// <summary>发票角色
/// </summary>
export const enum InvoiceRole {
  ///<summary>发票角色
  ///</summary>
  CategoryID = 222,
  ///<summary>公司
  ///</summary>
  CompanyID = 1813,
  ///<summary>个人
  ///</summary>
  People = 1815,
}
/// <summary>发票类型
/// </summary>
export const enum InvoiceType {
  ///<summary>发票类型
  ///</summary>
  CategoryID = 224,
  ///<summary>专票
  ///</summary>
  SpecialTicket = 1821,
  ///<summary>普票
  ///</summary>
  GeneralTicket = 1823,
}
/// <summary>取票类型
/// </summary>
export const enum TakeType {
  ///<summary>取票类型
  ///</summary>
  CategoryID = 226,
  ///<summary>电子发票
  ///</summary>
  Electronic = 1825,
  ///<summary>纸质发票
  ///</summary>
  Paper = 1827,
}

/// <summary>授权类型
/// </summary>
export const enum AuthType {
  /// <summary>授权类型
  /// </summary>
  CategoryID = 228,
  ///<summary>邮箱账号
  ///</summary>
  EmailAuth = 10220,
  ///<summary>手机账号
  ///</summary>
  MobileAuth = 10222,
  ///<summary>用户账号
  ///</summary>
  AccountAuth = 10224,

  ///<summary>微信授权
  ///</summary>
  WeixinAuth = 10230,

  ///<summary> 设备授权
  ///</summary>
  DeviceAuth = 10240,

  ///<summary>动态验证
  ///</summary>
  DynamicAuth = 10250,
}
/// <summary>通知类型
/// </summary>
export const enum NotifyType {
  ///<summary>通知类型
  ///</summary>
  CategoryID = 230,
  ///<summary>短信通知
  ///</summary>
  MessageNotify = 1865,
  ///<summary>邮件通知
  ///</summary>
  MailNotify = 1867,
  ///<summary>微信通知
  ///</summary>
  WechatNotify = 1869,
  ///<summary>App通知
  ///</summary>
  AppNotify = 1871,
}
/// <summary>逾期状态
/// </summary>
export const enum OverdueStatus {
  ///<summary>逾期状态
  ///</summary>
  CategoryID = 232,
  ///<summary>待出帐
  ///</summary>
  WaitOutDay = 1890,
  ///<summary>未逾期
  ///</summary>
  OverdueNo = 1892,
  ///<summary>已逾期
  ///</summary>
  OverdueYes = 1894,
}
/// <summary>
/// 促销规则
/// </summary>
export const enum SaleRuleType {
  ///<summary>促销规则
  ///</summary>
  CategoryID = 234,
  ///<summary>百分比
  ///</summary>
  Percentage = 1900,
  ///<summary>固定金额
  ///</summary>
  FixMoney = 1902,
  ///<summary>剔除价格
  ///</summary>
  RemovePrice = 1904,
}

/// <summary>
/// 成员类型
/// </summary>
export const enum MemberType {
  ///<summary>成员类型
  ///</summary>
  CategoryID = 236,
  ///<summary>创建者
  ///</summary>
  Creater = 1930,
  ///<summary>参与者
  ///</summary>
  Member = 1932,
  ///<summary>监察者
  ///</summary>
  Watcher = 1934,
}

///<summary>
///通知内容类型
///</summary>
export const enum NotifyContentType {
  ///<summary>通知内容类型
  ///</summary>
  CategoryID = 240,
  ///<summary>文本
  ///</summary>
  Text = 1940,
  ///<summary>HTML
  ///</summary>
  Html = 1945,
  ///<summary>链接
  ///</summary>
  Link = 1950,
  ///<summary>插件
  ///</summary>
  Plugin = 1955,
}
///<summary>
///通知范围
///</summary>
export const enum NotifyScope {
  ///<summary>通知范围
  ///</summary>
  CategoryID = 242,
  ///<summary>公司内部
  ///</summary>
  CompanyInternal = 1960,
  ///<summary>当前域名
  ///</summary>
  CurrentDomainName = 1962,
  ///<summary>所有域名
  ///</summary>
  AllDomainName = 1964,
}
///<summary>
///快递类型
///</summary>
export const enum ExpressType {
  ///<summary>快递类型
  ///</summary>
  CategoryID = 244,
  ///<summary>电子邮件
  ///</summary>
  Email = 1970,
  ///<summary>普通地址
  ///</summary>
  OrdinaryAddress = 1972,
}

/// <summary>
/// </summary>
export const enum DutyCode {
  ///<summary>成员类型
  ///</summary>
  CategoryID = 236,

  ///<summary>创建者
  ///</summary>
  Creater = "creater",

  ///<summary>参与者
  ///</summary>
  Member = "member",

  ///<summary>执行者
  ///</summary>
  Executer = "executer",
  ///<summary>订阅者
  ///</summary>
  Subscriber = "subscriber",
  ///<summary>监察者
  ///</summary>
  Watcher = "watcher",
}

/// <summary>
/// </summary>
export const enum SignCode {
  ///<summary>创建者
  ///</summary>
  And_Sign = "and_sign",

  ///<summary>参与者
  ///</summary>
  Or_Sign = "or_sign",
}

/// <summary>
/// </summary>
export const enum ExtraCode_Wechat {
  ///<summary>默认回复
  ///</summary>
  Receive_Reply = "wechat_receive_reply",

  ///<summary>关注回复
  ///</summary>
  Watch_Reply = "wechat_watch_reply",
}
/// <summary>
/// </summary>
export const enum OrderStatusCode {
  /// <summary>待预定
  /// </summary>
  WaitBooking = "orderstatus.waitbooking",
  /// <summary>待审批
  /// </summary>
  WaitApprove = "orderstatus.waitapprove",
  /// <summary>待核价
  /// </summary>
  WaitConfirm = "orderstatus.waitconfirm",
  /// <summary>待支付/待确认/待审批
  /// </summary>
  WaitPayment = "orderstatus.waitpayment",
  /// <summary>待处理
  /// </summary>
  WaitDispose = "orderstatus.waitdispose",
  /// <summary>已完成
  /// </summary>
  Finished = "orderstatus.finished",
  /// <summary>已取消
  /// </summary>
  Canceled = "orderstatus.canceled",
  /// <summary>已退回
  /// </summary>
  Rejected = "orderstatus.rejected",
  /// <summary>已拆分
  /// </summary>
  Discrete = "orderstatus.discrete",
  /// <summary>暂不能
  /// </summary>
  Cannot = "orderstatus.cannot",
  ///<summary>退票审批
  ///</summary>
  Amend = "orderstatus.amend",
}

export const enum ProductExtraCode {
  /// <summary>
  /// 机型
  /// </summary>
  AirplaneModel = "flight.AirplaneModel",
  /// <summary>
  /// 出发航站楼
  /// </summary>
  ConsumerTerm = "flight.ConsumerTerm",
  /// <summary>
  /// 到达航站楼
  /// </summary>
  FinishedTerm = "flight.FinishedTerm",
  /// <summary>
  /// 共享
  /// </summary>
  ShareAirwayCode = "flight.ShareProduce",
  /// <summary>
  /// 经停
  /// </summary>
  StopAirportCode = "flight.StopProduceName",
  /// <summary>
  /// 全价
  /// </summary>
  FullPrice = "flight.FullPrice ",
  /// <summary>
  /// 机建
  /// </summary>
  BuildPrice = "flight.BuildPrice",
  /// <summary>
  /// 燃油
  /// </summary>
  FuelPrice = "flight.FuelPrice",
  /// <summary>
  /// 政策编号
  /// </summary>
  PolicyId = "flight.PolicyId",
  /// <summary>
  /// 投放编号
  /// </summary>
  ThrowId = "flight.ThrowId",

  /// <summary>
  /// 票本类型
  /// </summary>
  TicketType = "flight.TicketType",
}
export const enum GoodExtraCode {
  /// <summary>
  /// 直减
  /// </summary>
  DirectReduction = "good.DirectReduction",

  /// <summary>
  /// 自付
  /// </summary>
  SelfPayment = "good.SelfPayment",
}
export const enum SupplyExtraCode {
  IBE = "IBE",
  Qunar = "Qunar",
}
export const enum AccessCode {
  Public = "public",
  Private = "private",
}
export const enum UnionStatus {
  Repair = "Repair",
  Enable = "enable",
  Disable = "disable",
}
export const enum TrafficGrade {
  ///<summary>服务级别
  ///</summary>
  CategoryID = 257,

  /// <summary>经济型
  /// </summary>
  Economy = 2131,

  /// <summary>舒适型
  /// </summary>
  Comfort = 2133,

  /// <summary>商务型
  /// </summary>
  Business = 2135,

  /// <summary>豪华型
  /// </summary>
  Luxury = 2137,
}
export const enum ServiceSecne {
  ///<summary>服务场景
  ///</summary>
  CategoryID = 255,

  /// <summary>商务用车
  /// </summary>
  Business = 2121,

  /// <summary>加班用车
  /// </summary>
  Work = 2123,

  /// <summary>出行用车
  /// </summary>
  Btrip = 2125,

  /// <summary>其他场景
  /// </summary>
  Other = 2127,
}

export class CityInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  CityID?: number;
  CityName?: string;
  CityCode?: string;
  CitySpell?: string;
  CityShortSpell?: string;
  CityEName?: string;
  CityLevel?: number;
  Lang?: string;
}
export class CityLevelEntity {
  CityID?: number;
  CityName?: string;
  CityLevel?: number;
}
export class ConfigInfo {
  ///<summary>配置编号
  ///</summary>
  ConfigID?: string;

  ///<summary>公司编号
  ///</summary>
  RoleID?: string;

  ///<summary>角色类型
  ///</summary>
  RoleType?: number;
  ///<summary>客户编号
  ///</summary>
  OwnerID?: string;

  ///<summary>角色类型
  ///</summary>
  OwnerType?: number;

  ///<summary>类别代码
  ///</summary>
  CategoryCode?: string;

  ///<summary>配置代码
  ///</summary>
  ConfigName?: string;

  ///<summary>配置代码
  ///</summary>
  ConfigCode?: string;

  ///<summary>配置
  ///</summary>
  ConfigValue?: string;
}
export class ContinentInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  Lang?: string;
}
export class CountryInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  CountryCode?: string;
  Lang?: string;
}
export class DistrictInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  CityID?: number;
  CityName?: string;
  CityCode?: string;
  CitySpell?: string;
  CityShortSpell?: string;
  CityEName?: string;
  DistrictID?: number;
  DistrictName?: string;
  Lang?: string;
}
export class ExtraInfoEntity {
  ExtraID?: string;
  ///<summary>扩展名称
  ///</summary>
  ExtraName?: string;
  ///<summary>扩展数据
  ///</summary>
  ExtraData?: string;
  ///<summary>扩展代码
  ///</summary>
  ExtraCode?: string;
  ///<summary>扩展组号(扩展行记录)
  ///</summary>
  ExtraGroup?: string;
  ///<summary>格式代码(text html url json xml)
  ///</summary>
  FormatCode?: string;
  ///<summary>目标编号
  ///</summary>
  IncludeID?: string;
  ///<summary>主要信息
  ///</summary>
  MasterID?: string;
  ///<summary>额外扩展(width)
  ///</summary>
  ExtraDataX?: string;
  ///<summary>额外扩展(height)
  ///</summary>
  ExtraDataY?: string;
  ///<summary>额外扩展(depth)
  ///</summary>
  ExtraDataZ?: string;
}
export class HotelGJCityEntity {
  HotelGJCityID?: number;
  CityID?: number;
  CityEnglish?: string;
  CityName?: string;
  CountryID?: number;
  CountryName?: string;
  CountryEnglish?: string;
  CountryCod?: string;
}
export class MapInfoEntity {
  MapId?: string;
  ZoneId?: string;
  ZoneCode?: string;
  OuterId?: string;
}
export class ProvinceInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  Lang?: string;
}
export class ScenicInfoEntity {
  PageNo?: number;
  PageSize?: number;
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  CityID?: number;
  CityName?: string;
  CityCode?: string;
  CitySpell?: string;
  CityShortSpell?: string;
  CityEName?: string;
  DistrictID?: number;
  DistrictName?: string;
  ScenicID?: number;
  ScenicName?: string;
  ScenicImg?: string;
  Lang?: string;
}
export class StationInfoEntity {
  StationID?: number;
  ///<summary>火车站点三字码
  ///</summary>
  StationCode?: string;
  ///<summary>火车站点名称
  ///</summary>
  StationName?: string;
  ///<summary>火车站点拼写
  ///</summary>
  StationSpell?: string;
  ///<summary>火车站点缩写
  ///</summary>
  StationShortSpell?: string;
  CountryID?: number;
  CountryName?: string;
  ///<summary>城市编号
  ///</summary>
  CityID?: number;
  ///<summary>城市名称
  ///</summary>
  CityName?: string;
  ///<summary>城市三字码
  ///</summary>
  CityCode?: string;
  ///<summary>城市拼写
  ///</summary>
  CitySpell?: string;
  ///<summary>城市缩写
  ///</summary>
  CityShortSpell?: string;
  CityEName?: string;
  Lang?: string;
}
export class TourCityEntity {
  TourCityID?: number;
  ///<summary>名称
  ///</summary>
  Name?: string;
  ///<summary>上级编号
  ///</summary>
  UpperID?: number;
}
export class TownInfoEntity {
  ContinentID?: number;
  ContinentName?: string;
  AreaID?: number;
  AreaName?: string;
  CountryID?: number;
  CountryName?: string;
  ProvinceID?: number;
  ProvinceName?: string;
  CityID?: number;
  CityName?: string;
  CityCode?: string;
  CitySpell?: string;
  CityShortSpell?: string;
  CityEName?: string;
  DistrictID?: number;
  DistrictName?: string;
  TownID?: number;
  TownName?: string;
  Lang?: string;
}
export class TrainCityInfoEntity {
  ///<summary>火车站编号
  ///</summary>
  TrainID?: string;
  ///<summary>城市编号
  ///</summary>
  CityID?: number;
  ///<summary>城市名称
  ///</summary>
  CityName?: string;
  ///<summary>城市三字码
  ///</summary>
  CityCode?: string;
  ///<summary>城市拼写
  ///</summary>
  CitySpell?: string;
  ///<summary>城市缩写
  ///</summary>
  CityShortSpell?: string;
  ///<summary>火车站点名称
  ///</summary>
  StationName?: string;
  ///<summary>火车站点三字码
  ///</summary>
  StationCode?: string;
  ///<summary>火车站点拼写
  ///</summary>
  StationSpell?: string;
  ///<summary>火车站点缩写
  ///</summary>
  StationShortSpell?: string;

  ///<summary>火车站编号
  ///</summary>
}
export class ZoneInfoEntity {
  PageSize?: number;
  PageNo?: number;
  ZoneTypes?: string;
  ZoneID?: number;
  ZoneName?: string;
  ZoneCode?: string;
  ZoneSpell?: string;
  ZoneShortSpell?: string;
  ZoneUpper?: number;
  ZoneType?: string;
  ContinentID?: number;
  ContinentName?: string;
  CountryID?: number;
  CountryName?: string;
  CityID?: number;
  CityCode?: string;
  CityName?: string;
  Keywords?: string;
  ///<summary>热门城市排序
  ///</summary>
  Orderby?: number;
  Lang?: string;
}
export class ZoneInfo {
  ZoneID?: string;
  ZoneName?: string;
  ZoneCode?: string;
  ZoneSpell?: string;
  ZoneShortSpell?: string;
  ZoneUpper?: string;
  ZoneType?: string;
  ZoneDatas?: ZoneInfo[];
  PageSize?: number;
  PageNo?: number;
}

//  export class CategoryInfo{

//  } Map(int? CategoryID)
//     {
//         return Map(CategoryID.Value);
//     }
// public static CategoryInfo Map(int CategoryID)
// {
//     CategoryInfo category;
//     if (categorys.TryGetValue(CategoryID, out category))
//     {
//         return category;
//     }
//     return new CategoryInfo();
// }
// public static string MapName(int? CategoryID)
// {
//     return MapName(CategoryID.Value);
// }
// public static string MapName(int CategoryID)
// {
//     return string.IsNullOrEmpty(Map(CategoryID).CategoryName) ? CategoryID.ToString() : Map(CategoryID).CategoryName;
// }
// public static string MapCode(int? CategoryID)
// {
//     return MapCode(CategoryID.Value);
// }
// public static string MapCode(int CategoryID)
// {
//     return string.IsNullOrEmpty(Map(CategoryID).CategoryCode) ? CategoryID.ToString() : Map(CategoryID).CategoryCode;
// }
export class CategoryInfo {
  CategoryID: number;
  BaseID: number;
  CategoryTitle: string;
  CategoryName: string;
  CategoryCode: string;
  CategoryOrder: number;

  constructor(categoryID: number, baseID: number, categoryTitle: string, categoryName: string, categoryCode: string, categoryOrder: number) {
    this.CategoryID = categoryID;
    this.BaseID = baseID;
    this.CategoryTitle = categoryTitle;
    this.CategoryName = categoryName;
    this.CategoryCode = categoryCode;
    this.CategoryOrder = categoryOrder;
  }
}

export const categoryMap: { [key: number]: CategoryInfo } = {
  111: new CategoryInfo(111, 0, "公司类型", "公司类型", "CompanyType", 0),
  112: new CategoryInfo(112, 0, "资本类型", "资本类型", "CapitalType", 0),
  113: new CategoryInfo(113, 0, "公司规模", "公司规模", "CompanySize", 0),
  114: new CategoryInfo(114, 0, "适用区域", "适用区域", "ApplyArea", 0),
  115: new CategoryInfo(115, 0, "证件类型", "证件类型", "CardType", 0),
  116: new CategoryInfo(116, 0, "用户状态", "用户状态", "UserStatus", 0),
  117: new CategoryInfo(117, 0, "性别", "性别", "Sex", 0),
  118: new CategoryInfo(118, 0, "是否", "是否", "YesOrNo", 0),
  119: new CategoryInfo(119, 0, "国内航程类型", "国内航程类型", "ChinaVoyageType", 0),
  120: new CategoryInfo(120, 0, "角色类型", "角色类型", "RoleType", 0),
  121: new CategoryInfo(121, 0, "支付方式", "支付方式", "PaymentType", 0),
  122: new CategoryInfo(122, 0, "航班类型", "航班类型", "FlightType", 0),
  123: new CategoryInfo(123, 0, "乘客类型", "乘客类型", "ConsumerType", 0),
  124: new CategoryInfo(124, 0, "账单周期", "账单周期", "BillCycle", 0),
  125: new CategoryInfo(125, 0, "服务方式", "服务方式", "ServiceMode", 0),
  126: new CategoryInfo(126, 0, "计算方式", "计算方式", "CalcPriceMode", 0),
  127: new CategoryInfo(127, 0, "计算基准", "计算基准", "CalcBenchmark", 0),
  130: new CategoryInfo(130, 0, "运行环境", "运行环境", "RuntimeEnvironment", 0),
  135: new CategoryInfo(135, 0, "工作状态", "工作状态", "WorkStatus", 0),
  136: new CategoryInfo(136, 0, "数据范围", "数据范围", "DataRange", 0),
  137: new CategoryInfo(137, 0, "授权状态", "授权状态", "AuthorizeState", 0),
  138: new CategoryInfo(138, 0, "角色类别", "角色类别", "RoleCategory", 0),
  139: new CategoryInfo(139, 0, "事件类型", "事件类型", "EventType", 0),
  140: new CategoryInfo(140, 0, "发票状态", "发票状态", "InvoiceStatus", 0),
  141: new CategoryInfo(141, 0, "下单方式", "下单方式", "CreateMode", 0),
  144: new CategoryInfo(144, 0, "价格单位", "价格单位", "UnitPrice", 0),
  145: new CategoryInfo(145, 0, "交易方式", "交易方式", "TradeMode", 0),
  146: new CategoryInfo(146, 0, "订单类型", "订单类型", "ProductType", 0),
  147: new CategoryInfo(147, 0, "文件类型", "文件类型", "FileType", 0),
  148: new CategoryInfo(148, 0, "留言类型", "留言类型", "MessageType", 0),
  150: new CategoryInfo(150, 0, "出游状态", "出游状态", "TravelStatus", 0),
  153: new CategoryInfo(153, 0, "业务类型", "业务类型", "BusinessType", 0),
  154: new CategoryInfo(154, 0, "安全类型", "安全类型", "SecurityType", 0),
  155: new CategoryInfo(155, 0, "订单来源", "订单来源", "CreateMode", 0),
  156: new CategoryInfo(156, 0, "服务类别", "服务类别", "ServiceType", 0),
  157: new CategoryInfo(157, 0, "问题类型", "问题类型", "ProblemType", 0),
  158: new CategoryInfo(158, 0, "联系方式", "联系方式", "ContactType", 0),
  159: new CategoryInfo(159, 0, "全局配置", "全局配置", "SetsType", 0),
  160: new CategoryInfo(160, 0, "团期状态", "团期状态", "TeamStatus", 0),
  161: new CategoryInfo(161, 0, "价格状态", "价格状态", "PriceStatus", 0),
  162: new CategoryInfo(162, 0, "政策类型", "政策类型", "PolicyType", 0),
  163: new CategoryInfo(163, 0, "收付款类别", "收付款类别", "TradeType", 0),
  164: new CategoryInfo(164, 0, "帐单状态", "帐单状态", "TradeStatus", 0),
  165: new CategoryInfo(165, 0, "审批状态", "审批状态", "AuditStatus", 0),
  166: new CategoryInfo(166, 0, "申请状态", "申请状态", "ApplyStatus", 0),
  167: new CategoryInfo(167, 0, "退团状态", "退团状态", "RefundStatus", 0),
  168: new CategoryInfo(168, 0, "区域类型", "区域类型", "ZoneType", 0),
  169: new CategoryInfo(169, 0, "取票方式", "取票方式", "TicketDelivery", 0),
  170: new CategoryInfo(170, 0, "票本类型", "票本类型", "TicketType", 0),
  171: new CategoryInfo(171, 0, "返回机场", "返回机场", "BackAirportType", 0),
  172: new CategoryInfo(172, 0, "适用对象", "适用对象", "ApplicableObject", 0),
  173: new CategoryInfo(173, 0, "适用价格", "适用价格", "ApplyPrice", 0),
  174: new CategoryInfo(174, 0, "适用周期", "适用周期", "ApplyWeek", 0),
  175: new CategoryInfo(175, 0, "不适用旅客资质", "不适用旅客资质", "LimitPassageType", 0),
  176: new CategoryInfo(176, 0, "运价基础中含规则", "运价基础中含规则", "FreightBasicsRule", 0),
  177: new CategoryInfo(177, 0, "儿童奖励规则", "儿童奖励规则", "ChildrewardRules", 0),
  178: new CategoryInfo(178, 0, "婴儿奖励规则", "婴儿奖励规则", "BabywardRules", 0),
  179: new CategoryInfo(179, 0, "换编码规则", "换编码规则", "CodingRule", 0),
  180: new CategoryInfo(180, 0, "国际航程类型", "国际航程类型", "InterVoyageType", 0),
  181: new CategoryInfo(181, 0, "扣点类型", "扣点类型", "PointsType", 0),
  182: new CategoryInfo(182, 0, "航线类型", "航线类型", "AirlineType", 0),
  183: new CategoryInfo(183, 0, "旅行须知类型", "旅行须知类型", "InformationsType", 0),
  184: new CategoryInfo(184, 0, "通知方式类型", "通知方式类型", "NotificationType", 0),
  185: new CategoryInfo(185, 0, "审批消息类型", "审批消息类型", "ExamineType", 0),
  186: new CategoryInfo(186, 0, "火车座位类型", "火车座位类型", "TrainSeatType", 0),
  187: new CategoryInfo(187, 0, "机票舱位", "机票舱位", "Cabin", 0),
  188: new CategoryInfo(188, 0, "最低价准则", "最低价准则", "LowestRule", 0),
  189: new CategoryInfo(189, 0, "火车类型", "火车类型", "TrainType", 0),
  190: new CategoryInfo(190, 0, "适用情况", "适用情况", "ApplicableCase", 0),
  191: new CategoryInfo(191, 0, "服务费类型", "服务费类型", "CollectFeesType", 0),
  192: new CategoryInfo(192, 0, "差旅原因类型", "差旅原因类型", "TravelReasonType", 0),
  193: new CategoryInfo(193, 0, "机票退票原因", "机票退票原因", "FlightRefundReason", 0),
  195: new CategoryInfo(195, 0, "预定类型", "预定类型", "BookingType", 0),
  196: new CategoryInfo(196, 0, "审批记录类型", "审批记录类型", "ApprovalRecordType", 0),
  197: new CategoryInfo(197, 0, "预定方式", "预定方式", "ReservationMode ", 0),
  198: new CategoryInfo(198, 0, "服务时间类型", "服务时间类型", "ServiceTimeType ", 0),
  199: new CategoryInfo(199, 0, "审批规则类型", "审批规则类型", "ScreeningRulesType", 0),
  200: new CategoryInfo(200, 0, "航班状态", "航班状态", "FlightTimeStatus", 0),
  201: new CategoryInfo(201, 0, "规则类型", "规则类型", "RuleType", 0),
  202: new CategoryInfo(202, 0, "机票费用类型", "机票费用类型", "ExpensesType", 0),
  203: new CategoryInfo(203, 0, "延期类型", "延期类型", "DelayType", 0),
  204: new CategoryInfo(204, 0, "价格类型", "价格类型", "PriceType", 0),
  206: new CategoryInfo(206, 0, "公司证件", "公司证件", "CompanyCard", 0),
  208: new CategoryInfo(208, 0, "活动状态", "活动状态", "ActiveStatus", 0),
  210: new CategoryInfo(210, 0, "处理流程", "处理流程", "FlowMode", 0),
  212: new CategoryInfo(212, 0, "账户类型", "账户类型", "AccountType", 0),
  214: new CategoryInfo(214, 0, "授信类型", "授信类型", "CreditType", 0),
  216: new CategoryInfo(216, 0, "账单状态", "账单状态", "BillStatus", 0),
  218: new CategoryInfo(218, 0, "订单状态", "订单状态", "OrderStatus", 0),
  220: new CategoryInfo(220, 0, "酒店退票原因", "酒店退票原因", "HotelRefundReason", 0),
  222: new CategoryInfo(222, 0, "发票角色", "发票角色", "InvoiceRole", 0),
  224: new CategoryInfo(224, 0, "发票类型", "发票类型", "InvoiceType", 0),
  226: new CategoryInfo(226, 0, "取票类型", "取票类型", "TakeType", 0),
  228: new CategoryInfo(228, 0, "授权方式", "授权方式", "AuthType", 0),
  230: new CategoryInfo(230, 0, "通知类型", "通知类型", "NotifyType", 0),
  232: new CategoryInfo(232, 0, "逾期状态", "逾期状态", "OverdueStatus", 0),
  234: new CategoryInfo(234, 0, "促销规则", "促销规则", "SaleRuleType", 0),
  236: new CategoryInfo(236, 0, "成员类型", "成员类型", "MemberType", 0),
  240: new CategoryInfo(240, 0, "通知内容类型", "通知内容类型", "NotifyContentType", 0),
  242: new CategoryInfo(242, 0, "通知范围", "通知范围", "NotifyScope", 0),
  244: new CategoryInfo(244, 0, "快递类型", "快递类型", "ExpressType", 0),
  255: new CategoryInfo(255, 0, "服务场景", "服务场景", "ServiceSecne", 0),
  257: new CategoryInfo(257, 0, "交通等级", "交通等级", "TrafficGrade", 0),

  1100: new CategoryInfo(1100, 111, "企事业单位", "企事业单位", "EnterprisesUnit", 0),
  1101: new CategoryInfo(1101, 111, "政府机关", "政府机关", "GovernmentDepartment", 0),
  1102: new CategoryInfo(1102, 112, "民营资产", "民营资产", "PeopleEnterprises", 0),
  1103: new CategoryInfo(1103, 112, "国有资产", "国有资产", "CountryCapital", 0),
  1104: new CategoryInfo(1104, 112, "中外合资", "中外合资", "ChinaOuterJoinCapital", 0),
  1105: new CategoryInfo(1105, 112, "外商独资", "外商独资", "ForeignCompany", 0),
  1106: new CategoryInfo(1106, 113, "100人以下", "100人以下", "CompanySize100", 0),
  1107: new CategoryInfo(1107, 113, "100~499", "100~499", "CompanySize499", 0),
  1108: new CategoryInfo(1108, 113, "500~999", "500~999", "CompanySize999", 0),
  1109: new CategoryInfo(1109, 113, "1000~4999", "1000~4999", "CompanySize4999", 0),
  1110: new CategoryInfo(1110, 113, "5000以上", "5000以上", "CompanySize5kUp", 0),
  1126: new CategoryInfo(1126, 114, "国内", "国内", "Internal", 0),
  1127: new CategoryInfo(1127, 114, "国际", "国际", "Overseas", 0),
  1138: new CategoryInfo(1138, 115, "身份证", "身份证", "IDCard", 0),
  1139: new CategoryInfo(1139, 115, "护照", "护照", "PassportCard", 0),
  1140: new CategoryInfo(1140, 115, "学生证", "学生证", "StudentCard", 0),
  1141: new CategoryInfo(1141, 115, "军人证", "军人证", "OfficerCard", 0),
  1234: new CategoryInfo(1234, 115, "港澳通行证", "港澳通行证", "HKCompatriotsyndrome", 0),
  1233: new CategoryInfo(1233, 115, "台湾通行证", "台湾通行证", "TaiCompatriotsyndrome", 0),
  // 1142: new CategoryInfo(1142, 115, "其它", "其它", "OtherCard", 0),
  1143: new CategoryInfo(1143, 116, "启用", "启用", "Enable", 0),
  1144: new CategoryInfo(1144, 116, "禁用", "禁用", "UnEnable", 0),
  1145: new CategoryInfo(1145, 117, "男", "男", "Male", 0),
  1146: new CategoryInfo(1146, 117, "女", "女", "Female", 0),
  1150: new CategoryInfo(1150, 118, "是", "是", "Yes", 0),
  1151: new CategoryInfo(1151, 118, "否", "否", "No", 0),
  1161: new CategoryInfo(1161, 119, "单程", "单程", "SingleVoyage", 0),
  1162: new CategoryInfo(1162, 119, "往返", "往返", "RoundVoyage", 0),
  1163: new CategoryInfo(1163, 119, "回程", "回程", "ReturnVoyage", 0),
  1164: new CategoryInfo(1164, 170, "BSP", "BSP", "BSP", 0),
  1165: new CategoryInfo(1165, 170, "B2B", "B2B", "B2B", 0),
  1166: new CategoryInfo(1166, 170, "境外电子", "境外电子", "OverseasElectronic", 0),
  1167: new CategoryInfo(1167, 119, "联程", "联程", "ConnectVoyage", 0),
  1168: new CategoryInfo(1168, 172, "团队", "团队", "Team", 0),
  1169: new CategoryInfo(1169, 172, "散客", "散客", "Fit", 0),
  1170: new CategoryInfo(1170, 172, "不限", "不限", "Unlimited", 0),
  1171: new CategoryInfo(1171, 173, "高开", "高开", "HighOpen", 0),
  1172: new CategoryInfo(1172, 173, "低开", "低开", "DownOpen", 0),
  1173: new CategoryInfo(1173, 174, "一", "星期一", "Monday", 0),
  1174: new CategoryInfo(1174, 174, "二", "星期二", "Tuesday", 0),
  1175: new CategoryInfo(1175, 174, "三", "星期三", "Wednesday", 0),
  1176: new CategoryInfo(1176, 174, "四", "星期四", "Thursday", 0),
  1177: new CategoryInfo(1177, 174, "五", "星期五", "Friday", 0),
  1178: new CategoryInfo(1178, 174, "六", "星期六", "Saturday", 0),
  1179: new CategoryInfo(1179, 174, "日", "星期日", "Sunday", 0),
  1180: new CategoryInfo(1180, 171, "同一洲际范围内", "同一洲际范围内", "WithinIntercontinental", 0),
  1181: new CategoryInfo(1181, 171, "政策始发机场范围", "政策始发机场范围", "PolicyDepartAirport", 0),
  1182: new CategoryInfo(1182, 176, "无奖励", "无奖励", "NoReward", 0),
  1183: new CategoryInfo(1183, 176, "无代理费", "无代理费", "AgencyFreeFee", 0),
  1184: new CategoryInfo(1184, 171, "必须返回行程出发机场", "必须返回行程出发机场", "MustBackAirport", 0),
  1185: new CategoryInfo(1185, 171, "指定返回国家或机场范围", "指定返回国家或机场范围", "AppointBackAirport", 0),
  1193: new CategoryInfo(1193, 122, "普通航班", "普通航班", "CommonFlight", 0),
  1194: new CategoryInfo(1194, 122, "共享航班", "共享航班", "ShareFlight", 0),
  1195: new CategoryInfo(1195, 121, "预付", "预付", "Prepay", 0),
  1196: new CategoryInfo(1196, 121, "现付", "现付", "CashPay", 0),
  1200: new CategoryInfo(1200, 175, "留学生", "留学生", "OverseasStudent", 0),
  1201: new CategoryInfo(1201, 175, "移民", "移民", "Immigrant", 0),
  1202: new CategoryInfo(1202, 175, "劳工", "劳工", "Worker", 0),
  1203: new CategoryInfo(1203, 175, "海员", "海员", "Seaman", 0),
  1204: new CategoryInfo(1204, 175, "青年", "青年", "Youth", 0),
  1205: new CategoryInfo(1205, 175, "港澳台", "港澳台", "HkMacaoTw", 0),
  1206: new CategoryInfo(1206, 175, "外籍", "外籍", "ForeignNationality", 0),
  1207: new CategoryInfo(1207, 175, "非汉字姓名", "非汉字姓名", "NotChineseName", 0),
  1208: new CategoryInfo(1208, 175, "Add-On", "Add-On", "AddOn", 0),
  1209: new CategoryInfo(1209, 175, "老年", "老年", "OldGge", 0),
  1210: new CategoryInfo(1210, 175, "境外中转", "境外中转", "OverseasTransfer", 0),
  1211: new CategoryInfo(1211, 175, "缺口程", "缺口程", "NotchRange", 0),
  1212: new CategoryInfo(1212, 175, "OPEN", "OPEN", "OPEN", 0),
  1213: new CategoryInfo(1213, 175, "SPA", "SPA", "SPA", 0),
  1214: new CategoryInfo(1214, 175, "Q值", "Q值", "QValue", 0),
  1215: new CategoryInfo(1215, 175, "共享航班", "共享航班", "SharedFlight", 0),
  1216: new CategoryInfo(1216, 175, "三方协议", "三方协议", "ThreeAgreement", 0),
  1217: new CategoryInfo(1217, 175, "套票", "套票", "Package", 0),
  1218: new CategoryInfo(1218, 175, "整团", "整团", "WholeGroup", 0),
  1219: new CategoryInfo(1219, 175, "小团", "小团", "SmallGroup", 0),
  1220: new CategoryInfo(1220, 177, "奖励与成人一样", "奖励与成人一样", "RewardsAdults", 0),
  1221: new CategoryInfo(1221, 177, "可无开奖励", "可无开奖励", "NoOpenBonus", 0),
  1222: new CategoryInfo(1222, 178, "可开无奖励", "可开无奖励", "WithoutReward", 0),
  1223: new CategoryInfo(1223, 178, "不可开", "不可开", "NotOpen", 0),
  1224: new CategoryInfo(1224, 179, "无需换编码", "无需还编码", "NoCodingRequired", 0),
  1225: new CategoryInfo(1225, 179, "换编码出票", "换编码出票", "CodeOut", 0),
  1226: new CategoryInfo(1226, 179, "大编出票（无需换编）", "大编出票（无需换编）", "BigTicket", 0),
  1227: new CategoryInfo(1227, 179, "大编出票（需换编）", "大编出票（需换编）", "BigNoTicket", 0),
  1228: new CategoryInfo(1228, 179, "无位不换出票（外放有位时换编）", "无位不换出票（外放有位时换编）", "NoChange", 0),
  1230: new CategoryInfo(1230, 180, "单程", "单程", "SingleVoyage", 0),
  1231: new CategoryInfo(1231, 180, "往返", "往返", "RoundVoyage", 0),
  1232: new CategoryInfo(1232, 180, "单程/往返", "单程/往返", "SingleRound", 0),
  1260: new CategoryInfo(1260, 124, "月", "月", "MonthCycle", 0),
  1261: new CategoryInfo(1261, 124, "周", "周", "WeekCycle", 0),
  1262: new CategoryInfo(1262, 124, "日", "日", "DayCycle", 0),
  1296: new CategoryInfo(1296, 115, "港澳台居民居住证", "港澳台居民居住证", "Residencepermit", 0),
  1297: new CategoryInfo(1297, 115, "外国人永久居留身份证", "外国人永久居留身份证", "ForeignResidentIDCard", 0),
  1298: new CategoryInfo(1298, 115, "回乡证", "回乡证", "HKMpermit", 0),
  1299: new CategoryInfo(1299, 115, "台胞证", "台胞证", "TaiWpermit", 0),
  1300: new CategoryInfo(1300, 125, "线上服务", "线上服务", "OnlineServiceMode", 0),
  1301: new CategoryInfo(1301, 125, "线下服务", "线下服务", "LineServiceMode", 0),
  1302: new CategoryInfo(1302, 126, "百分比", "百分比", "PercentageMode", 0),
  1303: new CategoryInfo(1303, 126, "固定金额", "固定金额", "FixedPrice", 0),
  1304: new CategoryInfo(1304, 127, "票面价", "票面价", "ExpensePrice", 0),
  1305: new CategoryInfo(1305, 127, "票面价+税费", "票面价+税费", "PriceFareAndTax", 0),
  1306: new CategoryInfo(1306, 181, "直接修改", "直接修改", "DirectUpdate", 0),
  1307: new CategoryInfo(1307, 181, "加点", "加点", "AddLittle", 0),
  1308: new CategoryInfo(1308, 181, "减点", "减点", "ReduceLittle", 0),
  1311: new CategoryInfo(1311, 120, "用户", "用户", "User", 0),
  1312: new CategoryInfo(1312, 120, "职称", "职称", "Jobs", 0),
  1313: new CategoryInfo(1313, 120, "群组", "群组", "Group", 0),
  1314: new CategoryInfo(1314, 120, "部门", "部门", "Department", 0),
  1315: new CategoryInfo(1315, 120, "公司", "公司", "Company", 0),
  1316: new CategoryInfo(1316, 120, "服务", "服务", "Service", 0),
  1317: new CategoryInfo(1317, 120, "客户", "客户", "Customer", 0),
  1318: new CategoryInfo(1318, 120, "权限", "权限", "Actions", 0),
  1319: new CategoryInfo(1319, 120, "成本中心", "成本中心", "CostCenter", 0),
  1320: new CategoryInfo(1320, 130, "服务端", "服务端", "Server", 0),
  1321: new CategoryInfo(1321, 130, "客户端", "客户端", "Client", 0),
  1325: new CategoryInfo(1325, 135, "正常", "正常", "Normal", 0),
  1326: new CategoryInfo(1326, 135, "变更", "变更", "Change", 0),
  1330: new CategoryInfo(1330, 136, "仅自己", "仅自己", "SelfOnly", 0),
  1331: new CategoryInfo(1331, 136, "自己及下级", "自己及下级", "SelfLower", 0),
  1332: new CategoryInfo(1332, 136, "不限制", "不限制", "NoLimit", 0),
  1335: new CategoryInfo(1335, 137, "未授权", "未授权", "UnAuthorized", 0),
  1336: new CategoryInfo(1336, 137, "已授权", "已授权", "Authorized", 0),
  1350: new CategoryInfo(1350, 138, "系统角色", "系统角色", "SystemRole", 0),
  1351: new CategoryInfo(1351, 138, "用户角色", "用户角色", "UserRole", 0),
  1356: new CategoryInfo(1356, 139, "继续之前", "继续之前", "ContinueBefore", 0),
  1357: new CategoryInfo(1357, 139, "继续之后", "继续之后", "ContinueAfter", 0),
  1358: new CategoryInfo(1358, 139, "退回之前", "退回之前", "ReturnBefore", 0),
  1359: new CategoryInfo(1359, 139, "退回之后", "退回之后", "ReturnAfter", 0),
  1360: new CategoryInfo(1360, 139, "变更之前", "变更之前", "ChangeBefore", 0),
  1361: new CategoryInfo(1361, 139, "变更之后", "变更之后", "ChangeAfter", 0),
  1362: new CategoryInfo(1362, 140, "需要发票", "需要发票", "NeedInvoice", 0),
  1363: new CategoryInfo(1363, 140, "不要发票", "不要发票", "NoInvoice", 0),
  1364: new CategoryInfo(1364, 141, "网站", "网站", "WEB", 0),
  1369: new CategoryInfo(1369, 144, "元", "元", "RMB", 0),
  1370: new CategoryInfo(1370, 144, "美元", "美元", "Dollar", 0),
  1371: new CategoryInfo(1371, 145, "支付宝", "支付宝", "Alipay", 0),
  1372: new CategoryInfo(1372, 145, "微信", "微信", "WeChat", 0),
  1373: new CategoryInfo(1373, 145, "现金", "现金", "Cash", 0),
  1374: new CategoryInfo(1374, 145, "月结", "月结", "Monthly", 0),
  1375: new CategoryInfo(1375, 146, "旅游", "旅游", "Tour", 0),
  1376: new CategoryInfo(1376, 146, "酒店", "酒店", "Hotel", 0),
  1377: new CategoryInfo(1377, 146, "机票", "机票", "Flight", 0),
  1378: new CategoryInfo(1378, 147, "出团通知书", "出团通知书", "AdviceNote", 0),
  1379: new CategoryInfo(1379, 147, "客人附件", "客人附件", "GuestEnclosure", 0),
  1381: new CategoryInfo(1381, 147, "其他", "其他", "other", 0),
  1382: new CategoryInfo(1382, 147, "电子合同", "电子合同", "Electronic", 0),
  1383: new CategoryInfo(1383, 148, "给客人留言", "给客人留言", "ClientMessage", 0),
  1384: new CategoryInfo(1384, 148, "给供应留言", "给供应留言", "SupplyMessage", 0),
  1385: new CategoryInfo(1385, 148, "给同事留言", "给同事留言", "WorkmateMessage", 0),
  1390: new CategoryInfo(1390, 150, "已出游", "已出游", "Traveled", 0),
  1391: new CategoryInfo(1391, 150, "未出游", "未出游", "NotTravel", 0),
  1395: new CategoryInfo(1395, 153, "变更", "变更", "Change", 0),
  1397: new CategoryInfo(1397, 153, "销售", "销售", "Sales", 0),
  1398: new CategoryInfo(1398, 153, "退款", "退款", "Refund", 0),
  1399: new CategoryInfo(1399, 154, "登录密码", "登录密码", "PasswordVerify", 0),
  1400: new CategoryInfo(1400, 154, "邮箱验证", "邮箱验证", "EmailVerify", 0),
  1401: new CategoryInfo(1401, 154, "手机验证", "手机验证", "PhoneVerify", 0),
  1402: new CategoryInfo(1402, 154, "实名验证", "实名验证", "NameVerify", 0),
  1403: new CategoryInfo(1403, 154, "安全问题", "安全问题", "SafetyProblem", 0),
  1404: new CategoryInfo(1404, 155, "网站", "网站", "WEB", 0),
  1405: new CategoryInfo(1405, 155, "手机", "手机", "APP", 0),
  1406: new CategoryInfo(1406, 156, "商旅服务", "商旅服务", "BtripService", 0),
  1407: new CategoryInfo(1407, 156, "酒店服务", "酒店服务", "HotelService", 0),
  1408: new CategoryInfo(1408, 156, "旅游服务", "旅游服务", "TourService", 0),
  1409: new CategoryInfo(1409, 156, "机票服务", "机票服务", "FlightService", 0),
  1470: new CategoryInfo(1470, 156, "火车服务", "火车服务", "TrainService", 0),
  1469: new CategoryInfo(1469, 156, "签证服务", "签证服务", "VisaService", 0),
  1556: new CategoryInfo(1556, 156, "商城服务", "商城服务", "MallService", 0),
  1410: new CategoryInfo(1410, 156, "增值服务", "增值服务", "ChargeService", 0),
  1466: new CategoryInfo(1466, 156, "保险服务", "保险服务", "InsuranceService", 0),
  1467: new CategoryInfo(1467, 156, "快递服务", "快递服务", "ExpressService", 0),
  1468: new CategoryInfo(1468, 156, "发票服务", "发票服务", "InvoiceService", 0),
  1557: new CategoryInfo(1557, 156, "基础服务", "基础服务", "BaseService", 0),
  1638: new CategoryInfo(1638, 156, "订单服务", "订单服务", "OrderService", 0),
  1640: new CategoryInfo(1640, 156, "账单服务", "账单服务", "BillService", 0),
  1637: new CategoryInfo(1637, 156, "工作服务", "工作服务", "WorkService", 0),
  1636: new CategoryInfo(1636, 156, "系统服务", "系统服务", "SystemService", 0),
  1554: new CategoryInfo(1554, 156, "餐饮服务", "餐饮服务", "CaterService", 0),
  1555: new CategoryInfo(1555, 156, "交通服务", "交通服务", "TrafficService", 0),
  1643: new CategoryInfo(1643, 156, "个人服务", "个人服务", "UserService", 0),
  1645: new CategoryInfo(1645, 156, "企业服务", "企业服务", "CompanyService", 0),
  1411: new CategoryInfo(1411, 157, "高中班主任是谁", "高中班主任是谁", "HightDirector", 0),
  1412: new CategoryInfo(1412, 157, "第一次通关的游戏", "第一次通关的游戏", "Firstgame", 0),
  1413: new CategoryInfo(1413, 158, "手机", "手机", "PhoneContact", 0),
  1414: new CategoryInfo(1414, 158, "电话", "电话", "TelephoneContact", 0),
  1415: new CategoryInfo(1415, 158, "邮箱", "邮箱", "EmailContact", 0),
  1416: new CategoryInfo(1416, 158, "QQ", "QQ", "QQ", 0),
  1417: new CategoryInfo(1417, 159, "网上预订须知", "网上预订须知", "OnlineKnow", 0),
  1418: new CategoryInfo(1418, 159, "国内旅游预订须知", "国内旅游预订须知", "TourKnow", 0),
  1419: new CategoryInfo(1419, 160, "启用", "启用", "Enable", 0),
  1420: new CategoryInfo(1420, 160, "禁用", "禁用", "UnEnable", 0),
  1421: new CategoryInfo(1421, 161, "价格启用", "价格启用", "PriceEnable", 0),
  1422: new CategoryInfo(1422, 161, "价格禁用", "价格禁用", "PriceUnEnable", 0),
  1423: new CategoryInfo(1423, 161, "价格待定", "价格待定", "Indeterminate", 0),
  1426: new CategoryInfo(1426, 162, "私有政策", "私有政策", "PrivatePolicy", 0),
  1427: new CategoryInfo(1427, 162, "公有政策", "公有政策", "PublicPolicy", 0),
  1428: new CategoryInfo(1428, 163, "收款", "收款", "Receive", 0),
  1429: new CategoryInfo(1429, 163, "付款", "付款", "Payment", 0),
  1432: new CategoryInfo(1432, 166, "未提交", "未提交", "Unsubmit", 0),
  1433: new CategoryInfo(1433, 166, "已提交", "已提交", "Submited", 0),
  1434: new CategoryInfo(1434, 165, "未审批", "未审批", "Unaudit", 0),
  1435: new CategoryInfo(1435, 165, "已审批", "已审批", "Audited", 0),
  1436: new CategoryInfo(1436, 165, "审批拒绝", "审批拒绝", "AuditRefuse", 0),
  1438: new CategoryInfo(1438, 167, "未处理", "未处理", "Untreated", 0),
  1439: new CategoryInfo(1439, 167, "退团失败", "退团失败", "RefundeBad", 0),
  1440: new CategoryInfo(1440, 167, "退团处理中", "退团处理中", "RefundeIng", 0),
  1441: new CategoryInfo(1441, 167, "退团成功", "退团成功", "Refunded", 0),
  1442: new CategoryInfo(1442, 168, "国家", "国家", "Country", 0),
  1443: new CategoryInfo(1443, 168, "景区", "景区", "Scenic", 0),
  1444: new CategoryInfo(1444, 168, "城市", "城市", "City", 0),
  1445: new CategoryInfo(1445, 168, "省", "省", "Province", 0),
  1446: new CategoryInfo(1446, 168, "区域", "区域", "Area", 0),
  1447: new CategoryInfo(1447, 168, "机场", "机场", "Airport", 0),
  1448: new CategoryInfo(1448, 168, "洲", "洲", "Continent", 0),
  1449: new CategoryInfo(1449, 168, "区", "区", "District", 0),
  1450: new CategoryInfo(1450, 169, "自取", "自取", "Invite", 0),
  1451: new CategoryInfo(1451, 169, "邮寄", "邮寄", "Mail", 0),
  1452: new CategoryInfo(1452, 182, "国内始发", "国内始发", "insideOutside", 0),
  1453: new CategoryInfo(1453, 182, "直飞SOTO程", "直飞SOTO程", "outsideInside", 0),
  1454: new CategoryInfo(1454, 182, "国内始发Add-On", "国内始发Add-On", "insideInsideOutside", 0),
  1455: new CategoryInfo(1455, 182, "国外始发Add-On", "国外始发Add-On", "outsideInsideInside", 0),
  1456: new CategoryInfo(1456, 182, "境外到境外", "境外到境外", "outsideOutside", 0),
  1457: new CategoryInfo(1457, 182, "国内始发中转", "国内始发中转", "insideOutsideOutside", 0),
  1458: new CategoryInfo(1458, 182, "国外始发中转", "国外始发中转", "outsideOutsideInside", 0),
  1459: new CategoryInfo(1459, 182, "境外境外境外", "境外境外境外", "outsideOutsideOutside", 0),
  1460: new CategoryInfo(1460, 182, "境外境内境外", "境外境内境外", "outsideInsideOutside", 0),
  1461: new CategoryInfo(1461, 182, "全球到全球", "全球到全球", "globalGlobal", 0),
  1462: new CategoryInfo(1462, 182, "全球中转全球", "全球中转全球", "globalGlobalGlobal", 0),
  1463: new CategoryInfo(1463, 177, "可开无代理费", "可开无代理费", "openAgencyFee", 0),
  1464: new CategoryInfo(1464, 177, "不可开", "不可开", "NoWay", 0),
  1471: new CategoryInfo(1471, 183, "预定须知", "预定须知", "TravelNotes", 0),
  1472: new CategoryInfo(1472, 183, "费用须知", "费用须知", "ExpenseKnowledge", 0),
  1473: new CategoryInfo(1473, 184, "短信", "短信", "ShortMessage", 0),
  1474: new CategoryInfo(1474, 184, "邮件", "邮件", "Mail", 0),
  1475: new CategoryInfo(1475, 184, "微信", "微信", "Wechat", 0),
  1476: new CategoryInfo(1476, 185, "审批订单消息内容", "审批订单消息内容", "EexamineOrderSms", 0),
  1477: new CategoryInfo(1477, 185, "审批通过消息内容", "审批通过消息内容", "EexamineApprovalSms", 0),
  1478: new CategoryInfo(1478, 185, "审批拒绝消息内容", "审批拒绝消息内容", "EexamineRefuseSms", 0),
  1479: new CategoryInfo(1479, 185, "订单处理完成消息内容", "订单处理完成消息内容", "EexamineAccomplishSms", 0),
  1480: new CategoryInfo(1480, 185, "退款完成", "退款完成", "Refunds", 0),
  1483: new CategoryInfo(1483, 145, "转账", "转账", "Transfer", 0),
  1484: new CategoryInfo(1484, 146, "火车票", "火车票", "Train", 0),
  1485: new CategoryInfo(1485, 186, "商务座", "商务座", "Business Class", 0),
  1486: new CategoryInfo(1486, 186, "特等座", "特等座", "Premier seat", 0),
  1487: new CategoryInfo(1487, 186, "一等座", "一等座", "1st Class", 0),
  1488: new CategoryInfo(1488, 186, "二等座", "二等座", "2nd Class", 0),
  1489: new CategoryInfo(1489, 186, "高级软卧", "高级软卧", "Deluxe sleeper", 0),
  1490: new CategoryInfo(1490, 186, "软卧", "软卧", "Soft sleeper", 0),
  1491: new CategoryInfo(1491, 186, "硬卧", "硬卧", "Hard sleeper", 0),
  1492: new CategoryInfo(1492, 186, "软座", "软座", "Soft seat", 0),
  1493: new CategoryInfo(1493, 186, "硬座", "硬座", "Hard seat", 0),
  1494: new CategoryInfo(1494, 186, "无座", "无座", "No seat", 0),
  1496: new CategoryInfo(1496, 187, "经济舱", "经济舱", "Economy", 0),
  1498: new CategoryInfo(1498, 187, "公务舱", "公务舱", "Buissenes", 0),
  1500: new CategoryInfo(1500, 187, "头等舱", "头等舱", "First", 0),
  0: new CategoryInfo(0, 188, "无限制", "无限制", "NoLimit", 0),
  1501: new CategoryInfo(1501, 188, "相对最低价", "相对最低价", "ControLowestPrice", 0),
  1502: new CategoryInfo(1502, 188, "全天最低价", "全天最低价", "DayLowestPrice", 0),
  1503: new CategoryInfo(1503, 188, "时段最低价", "时段最低价", "TimeAreaLowestPrice ", 0),
  1504: new CategoryInfo(1504, 188, "全航班最低价", "全航班最低价", "FlightLowestPrice", 0),
  1505: new CategoryInfo(1505, 189, "高铁", "高铁", "HighSpeedRail", 0),
  1506: new CategoryInfo(1506, 189, "卧铺", "卧铺", "SleepingBerth", 0),
  1507: new CategoryInfo(1507, 189, "普车及其它", "普车及其它", "Other", 0),
  1508: new CategoryInfo(1508, 190, "全部", "全部", "Whole", 0),
  1509: new CategoryInfo(1509, 190, "职位", "职位", "Position", 0),
  1510: new CategoryInfo(1510, 190, "部门", "部门", "Department", 0),
  1511: new CategoryInfo(1511, 191, "按固定收费", "按固定收费", "FlatFeeCharges", 0),
  1512: new CategoryInfo(1512, 191, "按百分比收费", "按百分比收费", "PercentageCostFee", 0),
  1513: new CategoryInfo(1513, 136, "本部门", "本部门", "Department", 0),
  1514: new CategoryInfo(1514, 136, "本部门及下级", "本部门及下级", "DepartmentLower", 0),
  1515: new CategoryInfo(1515, 192, "差旅目的", "差旅目的", "TravelPurpose", 0),
  1516: new CategoryInfo(1516, 192, "政策原因", "政策原因", "PolicyCause", 0),
  1517: new CategoryInfo(1517, 193, "我要改变行程,不想飞了", "我要改变行程,不想飞了", "FlightChange", 0),
  1518: new CategoryInfo(1518, 193, "记错行程、日期、时间、姓名", "记错行程、日期、时间、姓名", "FlightMistaken", 0),
  1519: new CategoryInfo(1519, 193, "航班延误或取消", "航班延误或取消", "FlightDelay", 0),
  1529: new CategoryInfo(1529, 195, "因公", "因公", "OnBusiness", 0),
  1530: new CategoryInfo(1530, 195, "因私", "因私", "OnPersonal", 0),
  1531: new CategoryInfo(1531, 196, "订单支付审批", "订单支付审批", "PayApproval", 0),
  1532: new CategoryInfo(1532, 196, "订单改签审批", "订单改签审批", "ChangeApproval", 0),
  1533: new CategoryInfo(1533, 196, "订单退票审批", "订单退票审批", "ReturnTicketApproval", 0),
  1534: new CategoryInfo(1534, 202, "按人收费", "按人收费", "People", 0),
  1535: new CategoryInfo(1535, 202, "按航段收费", "按航段收费", "legs", 0),
  1536: new CategoryInfo(1536, 197, "线上预定", "线上预定", "OnLineReservation  ", 0),
  1537: new CategoryInfo(1537, 197, "线下预定", "线下预定", "OffLineReservation  ", 0),
  1538: new CategoryInfo(1538, 198, "工作时间", "工作时间", "WorkingTime  ", 0),
  1539: new CategoryInfo(1539, 198, "非工作时间", "非工作时间", "NonWorkingTime  ", 0),
  1541: new CategoryInfo(1541, 199, "线上预定需要审批", "线上预定需要审批", "OnlineBookingApproval", 0),
  1542: new CategoryInfo(1542, 199, "线下预定需要审批", "线下预定需要审批", "OfflineBookingApproval", 0),
  1545: new CategoryInfo(1545, 199, "违背规则需要审批", "违背规则需要审批", "ViolateRuleApproval", 0),
  1546: new CategoryInfo(1546, 199, "更改行程需要审批", "更改行程需要审批", "ChangeTripApproval", 0),
  1547: new CategoryInfo(1547, 199, "取消行程需要审批", "取消行程需要审批", "CancelTripApproval", 0),
  1548: new CategoryInfo(1548, 200, "起飞前", "起飞前", "Preflight", 0),
  1549: new CategoryInfo(1549, 200, "起飞后", "起飞后", "AfterTakeoff", 0),
  1550: new CategoryInfo(1550, 201, "改签", "改签", "RuleEndorse", 0),
  1551: new CategoryInfo(1551, 201, "退票", "退票", "RuleFund", 0),
  1553: new CategoryInfo(1553, 201, "预定", "预定", "Reserve", 0),
  1559: new CategoryInfo(1559, 203, "自愿", "自愿", "Volunteer", 0),
  1561: new CategoryInfo(1561, 203, "航变", "航变", "FlightChang", 0),
  1563: new CategoryInfo(1563, 203, "重购", "重购", "BuyAgain", 0),
  1565: new CategoryInfo(1565, 203, "病退", "病退", "SickAmend", 0),
  1567: new CategoryInfo(1567, 203, "名字错误", "名字错误", "NameError", 0),
  1569: new CategoryInfo(1569, 203, "升舱换开", "升舱换开", "CabinChange", 0),
  1571: new CategoryInfo(1571, 203, "废票", "废票", "TicketInvalid", 0),
  1573: new CategoryInfo(1573, 203, "其他", "其他", "Other", 0),
  1610: new CategoryInfo(1610, 164, "待提交", "待提交", "WaitSubmit", 0),
  1612: new CategoryInfo(1612, 164, "待付款", "待付款", "WaitPayment", 0),
  1614: new CategoryInfo(1614, 164, "未确认", "未确认", "WaitConfirm", 0),
  1616: new CategoryInfo(1616, 164, "已确认", "已确认", "Finished", 0),
  1618: new CategoryInfo(1618, 164, "已取消", "已取消", "Canceled", 0),
  1620: new CategoryInfo(1620, 164, "已退回", "已退回", "Rejected", 0),
  1660: new CategoryInfo(1660, 204, "票面", "票面", "TicketFare", 0),
  1662: new CategoryInfo(1662, 204, "机建", "机建", "BuildFare", 0),
  1664: new CategoryInfo(1664, 204, "燃油", "燃油", "FuelFare", 0),
  1666: new CategoryInfo(1666, 204, "税费", "税费", "TaxFare", 0),
  1668: new CategoryInfo(1668, 204, "保险", "保险", "SafeFare", 0),
  1670: new CategoryInfo(1670, 204, "服务", "服务", "ServiceFare", 0),
  1672: new CategoryInfo(1672, 204, "房费", "房费", "HotelFare", 0),
  1674: new CategoryInfo(1674, 204, "团费", "团费", "TeamFare", 0),
  1678: new CategoryInfo(1678, 204, "退票", "退票", "AmendFare", 0),
  1682: new CategoryInfo(1682, 204, "变更", "变更", "ChangeFare", 0),
  1690: new CategoryInfo(1690, 204, "其它", "其它", "OtherFare", 0),
  1692: new CategoryInfo(1692, 204, "直减", "直减", "DirectReduction", 0),
  1701: new CategoryInfo(1701, 123, "婴儿", "婴儿", "Infant", 0),
  1703: new CategoryInfo(1703, 123, "儿童", "儿童", "Enfant", 0),
  1705: new CategoryInfo(1705, 123, "成人", "成人", "Young", 0),
  1707: new CategoryInfo(1707, 123, "中年", "中年", "Wrinkly", 0),
  1709: new CategoryInfo(1709, 123, "老年", "老年", "Elderly", 0),
  1720: new CategoryInfo(1720, 206, "营业执照", "营业执照", "BusinessLicence", 0),
  1722: new CategoryInfo(1722, 206, "税务登记证", "税务登记证", "TaxRegistration", 0),
  1730: new CategoryInfo(1730, 206, "其他", "其他", "Other", 0),
  1750: new CategoryInfo(1750, 208, "待提交", "待提交", "WaitSubmit", 0),
  1752: new CategoryInfo(1752, 208, "待处理", "待处理", "WaitDispose", 0),
  1754: new CategoryInfo(1754, 208, "暂不能", "暂不能", "Cannot", 0),
  1756: new CategoryInfo(1756, 208, "已完成", "已完成", "Finished", 0),
  1758: new CategoryInfo(1758, 208, "已拒绝", "已拒绝", "Rejected", 0),
  1760: new CategoryInfo(1760, 210, "审批", "审批", "Bill", 0),
  1765: new CategoryInfo(1765, 212, "余额", "余额", "Balance", 0),
  1767: new CategoryInfo(1767, 212, "信用", "信用", "Credit", 0),
  1769: new CategoryInfo(1769, 212, "积分", "积分", "Integral", 0),
  1771: new CategoryInfo(1771, 214, "固定授信", "固定授信", "FixedCredit", 0),
  1773: new CategoryInfo(1773, 214, "临时授信", "临时授信", "InterimCredit", 0),
  1777: new CategoryInfo(1777, 216, "待出帐", "待出帐", "WaitOutDay", 0),
  1779: new CategoryInfo(1779, 216, "待审核", "待审核", "WaitAudited", 0),
  1781: new CategoryInfo(1781, 216, "待确认", "待确认", "WaitConfirm", 0),
  1783: new CategoryInfo(1783, 216, "待收款", "待收款", "WaitReceive", 0),
  1785: new CategoryInfo(1785, 216, "已关账", "已关账", "Finished", 0),
  1787: new CategoryInfo(1787, 216, "已退回", "已退回", "Rejected", 0),
  1789: new CategoryInfo(1789, 153, "改换", "改换", "Change", 0),
  1791: new CategoryInfo(1791, 153, "账务", "账务", "Bill", 0),
  1792: new CategoryInfo(1792, 153, "发票", "发票", "Invoice", 0),
  1793: new CategoryInfo(1793, 153, "公司", "公司", "Company", 0),
  1795: new CategoryInfo(1795, 153, "产品", "产品", "Product", 0),
  1797: new CategoryInfo(1797, 153, "销售", "销售", "Sales", 0),
  1799: new CategoryInfo(1799, 153, "退费", "退费", "Amend", 0),
  1801: new CategoryInfo(1801, 153, "个人", "个人", "People", 0),
  1803: new CategoryInfo(1803, 155, "客服", "客服", "Customer", 0),
  1805: new CategoryInfo(1805, 220, "行程变更", "行程变更", "HotelChange", 0),
  1807: new CategoryInfo(1807, 168, "车站", "车站", "Station", 0),
  1813: new CategoryInfo(1813, 222, "公司", "公司", "CompanyID", 0),
  1815: new CategoryInfo(1815, 222, "个人", "个人", "People", 0),
  1821: new CategoryInfo(1821, 224, "专票", "专票", "SpecialTicket", 0),
  1823: new CategoryInfo(1823, 224, "普票", "普票", "GeneralTicket", 0),
  1825: new CategoryInfo(1825, 226, "电子发票", "电子发票", "Electronic", 0),
  1827: new CategoryInfo(1827, 226, "纸质发票", "纸质发票", "Paper", 0),
  1837: new CategoryInfo(1837, 220, "行程取消", "行程取消", "HotelDelay", 0),
  1851: new CategoryInfo(1851, 187, "5折经济舱", "5折经济舱", "Economy5", 0),
  1853: new CategoryInfo(1853, 187, "6折经济舱", "6折经济舱", "Economy6", 0),
  1855: new CategoryInfo(1855, 187, "7折经济舱", "7折经济舱", "Economy7", 0),
  1857: new CategoryInfo(1857, 187, "8折经济舱", "8折经济舱", "Economy8", 0),
  1859: new CategoryInfo(1859, 187, "9折经济舱", "9折经济舱", "Economy9", 0),
  1865: new CategoryInfo(1865, 230, "短信通知", "短信通知", "MessageNotify", 0),
  1867: new CategoryInfo(1867, 230, "邮件通知", "邮件通知", "MailNotify", 0),
  1869: new CategoryInfo(1869, 230, "微信通知", "微信通知", "WechatNotify", 0),
  1871: new CategoryInfo(1871, 230, "App通知", "App通知", "AppNotify", 0),
  1890: new CategoryInfo(1890, 232, "待出帐", "待出帐", "WaitOutDay", 0),
  1892: new CategoryInfo(1892, 232, "未逾期", "未逾期", "OverdueNo", 0),
  1894: new CategoryInfo(1894, 232, "已逾期", "已逾期", "OverdueYes", 0),
  1900: new CategoryInfo(1900, 234, "百分比", "百分比", "Percentage", 0),
  1902: new CategoryInfo(1902, 234, "固定金额", "固定金额", "FixMoney", 0),
  1904: new CategoryInfo(1904, 234, "剔除价格", "剔除价格", "RemovePrice", 0),
  1930: new CategoryInfo(1930, 236, "创建者", "创建者", "Creater", 0),
  1932: new CategoryInfo(1932, 236, "参与者", "参与者", "Member", 0),
  1934: new CategoryInfo(1934, 236, "关注者", "关注者", "Watcher", 0),
  1940: new CategoryInfo(1940, 240, "文本", "文本", "Text", 0),
  1945: new CategoryInfo(1945, 240, "HTML", "HTML", "Html", 0),
  1950: new CategoryInfo(1950, 240, "链接", "链接", "Link", 0),
  1955: new CategoryInfo(1955, 240, "插件", "插件", "Plugin", 0),
  1960: new CategoryInfo(1960, 242, "公司内部", "公司内部", "CompanyInternal", 0),
  1962: new CategoryInfo(1962, 242, "当前域名", "当前域名", "CurrentDomainName", 0),
  1964: new CategoryInfo(1964, 242, "所有域名", "所有域名", "AllDomainName", 0),
  1970: new CategoryInfo(1970, 244, "电子邮件", "电子邮件", "Email", 0),
  1972: new CategoryInfo(1972, 244, "普通地址", "普通地址", "OrdinaryAddress", 0),
  10101: new CategoryInfo(10101, 218, "待预定", "待预定", "WaitBooking", 0),
  10103: new CategoryInfo(10103, 218, "待审批", "待审批", "WaitApprove", 0),
  10105: new CategoryInfo(10105, 218, "待确认", "待确认", "WaitConfirm", 0),
  10107: new CategoryInfo(10107, 218, "待支付", "待支付", "WaitPayment", 0),
  10109: new CategoryInfo(10109, 218, "待处理", "待处理", "WaitDispose", 0),
  10113: new CategoryInfo(10113, 218, "已完成", "已完成", "Finished", 0),
  10115: new CategoryInfo(10115, 218, "已取消", "已取消", "Canceled", 0),
  10117: new CategoryInfo(10117, 218, "已退回", "已退回", "Rejected", 0),
  10119: new CategoryInfo(10119, 218, "已拆分", "已拆分", "Discrete", 0),
  10121: new CategoryInfo(10121, 218, "暂不能", "暂不能", "Cannot", 0),
  10220: new CategoryInfo(10220, 228, "邮箱账号", "邮箱账号", "EmailAuth", 0),
  10222: new CategoryInfo(10222, 228, "手机账号", "手机账号", "MobileAuth", 0),
  10224: new CategoryInfo(10224, 228, "用户账号", "用户账号", "AccountAuth", 0),
  10230: new CategoryInfo(10230, 228, "微信授权", "微信授权", "WeixinAuth", 0),
  10250: new CategoryInfo(10250, 228, "动态验证", "动态验证", "DynamicAuth", 0),
  2131: new CategoryInfo(2131, 257, "经济型", "经济型", "Economy", 0),
  2133: new CategoryInfo(2133, 257, "舒适型", "舒适型", "Comfort", 0),
  2135: new CategoryInfo(2135, 257, "商务型", "商务型", "Business", 0),
  2137: new CategoryInfo(2137, 257, "豪华型", "豪华型", "Luxury", 0),

  2121: new CategoryInfo(2121, 255, "商务用车", "商务用车", "Business", 0),
  2123: new CategoryInfo(2123, 255, "加班用车", "加班用车", "Work", 0),
  2125: new CategoryInfo(2125, 255, "出差用车", "出差用车", "Btrip", 0),
  2127: new CategoryInfo(2127, 255, "其他场景", "其他场景", "Other", 0),
};
